import { useEffect, useMemo, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import useFieldItem from "../../widgets/fields/UseFieldItem";
import { languagesData } from "../common/utils/languagesData";
import { fetchNextVariable, getFormVariables, getNonSurveyForm, getRecordsUidFields, getRules, getVarConfig, postSearchIndex, submitIdentifierForm, updateIdentifierForm } from "../dataCollection/apiController";
import { FIELD_TYPES, FieldItem } from "../../widgets/fields";
import { SurveyFormElements } from "./formElements";
import { Col, Row } from "reactstrap";
import { CustomButton, showToaster, toasterTypes } from "../../widgets";
import { cloneDeep, flatMap, get, remove, set } from "lodash";
import { getNextQuestion, submitForm, validateForm, validateSurveyForm } from "./apiController";
import { authSelector, setLoading } from "../../store/slices/auth";
import * as formula from "../common/formulafunction/Formulas";
import ModalPopup from "../../widgets/modal";
import { uploadPhoto } from "../profile/apiController";
import { Parser } from "expr-eval";
import { useLocation, useNavigate } from "react-router-dom";
import { CheckCircleOutlined, DatabaseFilled } from "@ant-design/icons";
import ExistingDataModal from "../dataCollection/ExistingDataModal";
import { ModifyReasonModal } from "../dataCollection/ModifyReasonModal";
import SpeechToTextDataEntry from "../dataCollection/SpeechToTextDataEntry";
import { flushSync } from "react-dom";
import TableViewData from "../dataCollection/TableViewData";
import dayjs from "dayjs";
// import ConversationRecording, { ConversationRecordingRef } from "../dataCollection/ConversationRecording";
import { fetchUserCredits } from "../literatureSearch/apiController";
import SpeechToTextButton from "../common/CustomButtons/SpeechToTextButton";
import SttConversationButton from "../common/CustomButtons/SttConversationButton";
import SearchIndexTabs from "../dataCollection/SearchIndexTabs";
import { convertISTTimeToUTC, convertUTCTimeToIST } from "../../utils/ConvertUTCToLocale";

const COMMUNICATION_CC_PC = "cc_pc";
const COMMUNICATION_CC_TC = "cc_tc";
const COMMUNICATION_CC_MSG_LK = "cc_msg_lk";
const COMMUNICATION_CC_SC = "cc_sc";

interface SurveyProps {
  page?: number,
  onSubmit?(): void | any,
  formData?: SurveyFormData,
  authenticatorData?: any
}

interface SurveyFormData {
  form_type: string;
  id?: string,
  form_name?: string,
  form_desc?: string,
  banner_image?: string;
  form_fields: {
    field_selected_value?: any; id?: string, form_id?: string, action_enabled?: boolean, fieldId?: string, field_name: string; field_type: string; field_category: string; field_value?: any; validations?: any; field_max_value?: any; field_min_value: any; field_row_value?: any
  }[]
}

interface Uid {
  uidFieldId: string;
  uidValue: string;
  uidFieldName: string;
}

// Cookie utilities
const setCookie = (name: string, value: string, days: number) => {
  const d = new Date();
  d.setTime(d.getTime() + days * 24 * 60 * 60 * 1000);
  const expires = "expires=" + d.toUTCString();
  document.cookie = `${name}=${value};${expires};path=/`;
};

const getCookie = (name: string) => {
  const cookies = document.cookie.split(';');
  for (let cookie of cookies) {
    cookie = cookie.trim();
    if (cookie.startsWith(name + '=')) {
      return cookie.split('=')[1];
    }
  }
  return null;
};

const incrementSubmissionCount = (formId: string) => {
  // read existing count
  const cookieValue = getCookie(`form_${formId}`);
  let count = cookieValue ? parseInt(cookieValue) : 0;

  // increment and store with 90 days expiry
  count += 1;
  setCookie(`form_${formId}`, count.toString(), 90); // 90 days expiry
  return;
};



const SurveyFormComponent = (props: any) => {
  const gridFields = ["checkBoxGrid", "radioButtonGrid", "textBoxGrid"];
  const dispatch = useDispatch();
  const FormElements = {
    fieldValue: {
      name: "fieldValue",
      label: "",
      isMandatory: true
    }
  }

  const [values, fields, handleChange, { validateValues, reset, updateValue, updateError, updateAllError, removeErrors }] = useFieldItem(FormElements, {}, { onValueChange });
  const [formData, setFormData] = useState<any>(props.formData)
  const [projectData, setProjectData] = useState<any>(props?.projectData || {});
  const [formFields, setFormFields] = useState<any>([]);
  const [selectedLanguage, setSelectedLanguage] = useState<any>({ label: "English", value: "en" });
  const [numberOfSpeakers, setNumberOfSpeakers] = useState<any>(1);
  const [promptMessage, setPromptMessage] = useState<string>("");
  const [rules, setRules] = useState<any>([]);
  const [isSubmitted, setIsSubmitted] = useState<boolean>(false);
  const [customMessage, setCustomMessage] = useState<any>("");
  const [isCurrentFormSubmitted, setIsCurrentFormSubmitted] = useState<boolean>(false);
  const [currentFormSubmittedMessage, setCurrentFormSubmittedMessage] = useState<string>("");
  const [page, setPage] = useState<number>(0);
  const [disabledFields, setDisabledFields] = useState<string[]>([]);
  const [isSubmit, setIsSubmit] = useState<boolean>(false);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  // const [startTime, setStartTime] = useState<Date>();
  // const [startEndTime, setStartEndTime] = useState<any>()
  const [formStartTime, setFormStartTime] = useState<any>()
  const fileUploadFields = ["fileUploadOCR", "fileUpload", "imageCapture", "videoCapture", "audioCapture", "signatureCapture"];
  const renderedCategoriesRef = new Map<number, Set<string>>();
  const [configData, setConfigData] = useState<any>();
  const [submitMessage, setSubmitMessage] = useState<string>("There are no more actions as per the answers submitted.");
  const [noMoreFields, setNoMoreFields] = useState<boolean>(false);
  const [permissionData, setPermissionData] = useState({});
  const [moduleType, setModuleType] = useState<string>("");
  const [existingData, setExistingData] = useState<any>(null);
  const [isExist, setIsExist] = useState<boolean>(false);
  const [isLocked, setIsLocked] = useState<boolean>(false);
  const [existSelectedData, setExistSelectedData] = useState<boolean>(false);
  const [isModifyData, setIsModifyData] = useState<boolean>(false);
  const [isModifyPartial, setIsModifyPartial] = useState<boolean>(false);
  const [modifyPartialFieldIds, setModifyPartialFieldIds] = useState<string[]>([]);
  const [receivedFieldsData, setReceivedFieldsData] = useState<any[]>([]);
  const [closeWebSocketConnection, setCloseWebSocketConnection] = useState(false);
  const [tableView, setTableView] = useState<boolean>(false);
  const [tableFormData, setTableFormData] = useState<any>();
  const [searchIndexUidData, setSearchIndexUidData] = useState<any>(null);
  const [isMasterFlow, setIsMasterFlow] = useState<boolean>(false);
  const [masterUidData, setMasterUidData] = useState<any>(null);
  const [showSearchIndexTabs, setShowSearchIndexTabs] = useState(false);
  const [autofillFieldValues, setAutofillFieldValues] = useState<any[]>([]);

  const projectDataPerm = useSelector(authSelector)

  const conversationFormNames = ["conversation", "cst"];

  // const conversationRecordingRef = useRef<ConversationRecordingRef>(null);
  const [uploading, setUploading] = useState<boolean>(false);
  const hasCalledClose = useRef(false);
  const closeTimeoutRef = useRef<any>(null);

  // Add a state to track when formFields update is done
  const [shouldProceed, setShouldProceed] = useState(false);

  const [componentState, setComponentState] = useState<any>();
  const [isCreditsAvailable, setIsCreditsAvailable] = useState<boolean>(false);

  const modifyReasonTypes = ["modify", "modifyPartial"];

  const loc = useLocation();
  const navigate = useNavigate();

  const location = {
    state: props
  }

  useEffect(() => {
    if (shouldProceed) {
      next({ currentFormFields: formFields });
      setShouldProceed(false); // reset flag
    }
  }, [formFields]);

  useEffect(() => {
    return () => {
      if (closeTimeoutRef.current) {
        clearTimeout(closeTimeoutRef.current);
      }
    };
  }, []);

  const handleCommunicationFormLogic = (fFields) => {
    const formsList = JSON.parse(localStorage.getItem("formsList") || "[]");
    const tempList = formsList;
    if (componentState?.data?.form_name.includes(COMMUNICATION_CC_SC) && tempList) {
      let isChanged = false;
      const updatedFormFields = cloneDeep(fFields);

      updatedFormFields.forEach(pageFields => {
        pageFields.forEach(field => {
          if (["Schedule Form Id", "Watch Field Id", "Target Uid Form Id", "Target Form Users Id"].includes(field.field_name) && !field.is_hidden) {
            field.is_hidden = true;
            isChanged = true;
          }
          if (field.field_name === "Schedule Form" && field.field_type !== "dropDown") {
            field.field_type = "dropDown";
            field.field_value = tempList.map(form => ({ label: form.form_name, value: form.form_name }));
            isChanged = true;
          }
          if (field.field_name === "Target Uid Form") {
            if (field.field_type !== "dropDown" || !field.field_value?.some((opt) => opt.value === "null_value")) {
              field.field_type = "dropDown";
              const options = tempList.map(form => ({ label: form.form_name, value: form.form_name }));
              options.unshift({ label: "None", value: "null_value" });
              field.field_value = options;
              isChanged = true;
            }
          }
        });
      });

      if (isChanged) setFormFields(updatedFormFields);

    } else if (componentState?.data?.form_name.includes(COMMUNICATION_CC_PC) && tempList) {
      let isChanged = false;
      const updatedFormFields = cloneDeep(fFields);

      updatedFormFields.forEach(pageFields => {
        pageFields.forEach(field => {
          if (["Form Id", "Field Id"].includes(field.field_name) && !field.is_hidden) {
            field.is_hidden = true;
            isChanged = true;
          }
          if (field.field_name === "Form Name" && field.field_type !== "dropDown") {
            field.field_type = "dropDown";
            field.field_value = tempList.map(form => ({ label: form.form_name, value: form.form_name }));
            isChanged = true;
          }
        });
      });

      if (isChanged) {
        setFormFields(updatedFormFields);
      }
    } else if (componentState?.data?.form_name.includes(COMMUNICATION_CC_MSG_LK) && tempList) {
      let isChanged = false;
      const updatedFormFields = cloneDeep(fFields);
      updatedFormFields.forEach(pageFields => {
        pageFields.forEach(field => {
          if (field.field_name === "Form Id" && !field.is_hidden) {
            field.is_hidden = true;
            isChanged = true;
          }
          if (field.field_name === "Form Name" && field.field_type !== "dropDown") {
            field.field_type = "dropDown";
            field.field_value = tempList.map(form => ({
              label: form.form_name,
              value: form.form_name,
            }));
            isChanged = true;
          }
        });
      });
      if (isChanged) {
        setFormFields(updatedFormFields);
      }
    } else if (componentState?.data?.form_name.includes(COMMUNICATION_CC_TC) && tempList) {
      let isChanged = false;
      const updatedFormFields = cloneDeep(fFields);

      updatedFormFields.forEach(pageFields => {
        pageFields.forEach(field => {
          if (["Target Uid Form Id", "Target Form Users Id", "Target Data Collection Form Id"].includes(field.field_name) && !field.is_hidden) {
            field.is_hidden = true;
            isChanged = true;
          }
          if (field.field_name === "Target Uid Form") {
            if (field.field_type !== "dropDown" || !field.field_value?.some((opt) => opt.value === "null_value")) {
              field.field_type = "dropDown";
              const options = tempList.map(form => ({ label: form.form_name, value: form.form_name }));
              options.unshift({ label: "None", value: "null_value" });
              field.field_value = options;
              isChanged = true;
            }
          }
          if (field.field_name === "Target Data Collection Form") {
            if (field.field_type !== "dropDown" || !field.field_value?.length) {
              field.field_type = "dropDown";
              field.field_value = tempList.map(form => ({ label: form.form_name, value: form.form_name }));
              isChanged = true;
            }
          }
        });
      });

      if (isChanged) {
        setFormFields(updatedFormFields);
      }
    }
  }

  useEffect(() => {
    if (formFields.length > 0 && componentState) {
      handleCommunicationFormLogic(formFields);
    }
  }, [componentState, formFields]);

  const updateCommunicationFields = async (updatedField, currentFormFields) => {
    const formsList = JSON.parse(localStorage.getItem("formsList") || "[]");
    const tempList = formsList;
    const newFields = cloneDeep(currentFormFields);

    //Always preserve the triggering field's selected value
    newFields.forEach(pageFields => {
      const self = pageFields.find(f => f.field_name === updatedField.field_name);
      if (self) {
        self.field_selected_value = updatedField.field_selected_value;
      }
    });

    if (
      updatedField.field_name === "Form Name" &&
      (componentState?.data?.form_name.includes(COMMUNICATION_CC_PC) ||
        componentState?.data?.form_name.includes(COMMUNICATION_CC_MSG_LK))
    ) {
      const selectedValue = updatedField.field_selected_value;
      const valToCheck = typeof selectedValue === "object" ? selectedValue?.value : selectedValue;
      const selectedForm = tempList.find(f => f.form_name === valToCheck);

      if (selectedForm) {
        newFields.forEach(pageFields => {
          const formIdField = pageFields.find(f => f.field_name === "Form Id");
          if (formIdField) {
            formIdField.field_selected_value = selectedForm.id;
          }
        });

        if (componentState?.data?.form_name.includes(COMMUNICATION_CC_PC)) {
          try {
            dispatch(setLoading(true));
            const response = await getFormVariables(selectedForm.id);
            if (response?.data) {
              newFields.forEach(pageFields => {
                const fieldNameField = pageFields.find(f => f.field_name === "Field Name");
                if (fieldNameField) {
                  fieldNameField.field_type = "dropDown";
                  fieldNameField.field_value = response.data.map(v => ({
                    label: v.field_name,
                    value: v.field_name,
                    ...v
                  }));
                  fieldNameField.field_selected_value = null;
                }
                const fieldIdField = pageFields.find(f => f.field_name === "Field Id");
                if (fieldIdField) {
                  fieldIdField.field_selected_value = null;
                }
              });
            }
          } catch (error) {
            console.error("Error fetching form variables", error);
          } finally {
            dispatch(setLoading(false));
          }
        }
      }
    } else if (updatedField.field_name === "Field Name") {
      const selectedValue = updatedField.field_selected_value;
      const valToCheck = typeof selectedValue === "object" ? selectedValue?.value : selectedValue;
      const selectedOption = updatedField.field_value?.find(opt => opt.value === valToCheck);

      if (selectedOption) {
        newFields.forEach(pageFields => {
          const fieldIdField = pageFields.find(f => f.field_name === "Field Id");
          if (fieldIdField) {
            fieldIdField.field_selected_value = selectedOption.id;
          }
        });
      }
    } else if (updatedField.field_name === "Target Uid Form") {
      const selectedValue = updatedField.field_selected_value;
      const valToCheck = typeof selectedValue === "object" ? selectedValue?.value : selectedValue;

      if (valToCheck === "null_value") {
        newFields.forEach(pageFields => {
          const usersField = pageFields.find(f => f.field_name === "Target Form Users");
          if (usersField) {
            usersField.field_type = "multiSelect";
            usersField.field_value = [];
            usersField.field_selected_value = null;
          }
          const targetUidFormIdField = pageFields.find(f => f.field_name === "Target Uid Form Id");
          if (targetUidFormIdField) {
            targetUidFormIdField.field_selected_value = null;
          }
        });
      } else {
        const selectedForm = tempList.find(f => f.form_name === valToCheck);
        if (selectedForm) {
          newFields.forEach(pageFields => {
            const targetUidFormIdField = pageFields.find(f => f.field_name === "Target Uid Form Id");
            if (targetUidFormIdField) {
              targetUidFormIdField.field_selected_value = selectedForm.id;
            }
          });

          try {
            dispatch(setLoading(true));
            const topicId = componentState?.projectData?.TopicID;
            const response = await getRecordsUidFields(topicId, selectedForm.id);
            const users = response?.data || [];
            const userOptions = users.map(user => ({
              label: user.field_selected_value,
              value: user.record_id,
              ...user
            }));

            newFields.forEach(pageFields => {
              const usersField = pageFields.find(f => f.field_name === "Target Form Users");
              if (usersField) {
                usersField.field_value = userOptions;

                if (usersField.field_selected_value) {
                  const currentSelections = Array.isArray(usersField.field_selected_value)
                    ? usersField.field_selected_value
                    : [usersField.field_selected_value];

                  const resolvedSelections = currentSelections.map(sel => {
                    const val = typeof sel === "object" ? sel.label || sel.value : sel;
                    return userOptions.find(opt => opt.label === val) || sel;
                  });

                  usersField.field_selected_value = resolvedSelections;

                  const usersIdField = pageFields.find(f => f.field_name === "Target Form Users Id");
                  if (usersIdField) {
                    usersIdField.field_selected_value = resolvedSelections.map(
                      s => s.record_id || s.value || s
                    );
                  }
                } else {
                  usersField.field_selected_value = null;
                }
              }
            });
          } catch (error) {
            console.error("Error fetching target form users", error);
          } finally {
            dispatch(setLoading(false));
          }
        }
      }
    } else if (updatedField.field_name === "Target Form Users") {
      const selectedValue = updatedField.field_selected_value;
      const ids = Array.isArray(selectedValue)
        ? selectedValue.map(item => item?.record_id || (item?.value ?? item))
        : [];

      newFields.forEach(pageFields => {
        const usersIdField = pageFields.find(f => f.field_name === "Target Form Users Id");
        if (usersIdField) {
          usersIdField.field_selected_value = ids;
        }
      });
    } else if (updatedField.field_name === "Target Data Collection Form") {
      const selectedValue = updatedField.field_selected_value;
      const valToCheck = typeof selectedValue === "object" ? selectedValue?.value : selectedValue;
      const selectedForm = tempList.find(f => f.form_name === valToCheck);
      if (selectedForm) {
        newFields.forEach(pageFields => {
          const targetDCFormIdField = pageFields.find(f => f.field_name === "Target Data Collection Form Id");
          if (targetDCFormIdField) {
            targetDCFormIdField.field_selected_value = selectedForm.id;
          }
        });
      }
    } else if (
      updatedField.field_name === "Schedule Form" &&
      componentState?.data?.form_name.includes(COMMUNICATION_CC_SC)
    ) {
      const selectedValue = updatedField.field_selected_value;
      const valToCheck = typeof selectedValue === "object" ? selectedValue?.value : selectedValue;
      const selectedForm = tempList.find(f => f.form_name === valToCheck);

      if (selectedForm) {
        // Auto-populate Schedule Form Id
        newFields.forEach(pageFields => {
          const formIdField = pageFields.find(f => f.field_name === "Schedule Form Id");
          if (formIdField) {
            formIdField.field_selected_value = selectedForm.id;
          }
        });

        try {
          dispatch(setLoading(true));
          const response = await getFormVariables(selectedForm.id);
          if (response?.data) {
            newFields.forEach(pageFields => {
              const watchField = pageFields.find(f => f.field_name === "Watch Field");
              if (watchField) {
                watchField.field_type = "dropDown";
                watchField.field_value = response.data.map(v => ({
                  label: v.field_name,
                  value: v.field_name,
                  ...v
                }));
                watchField.field_selected_value = null;
              }
              const watchFieldId = pageFields.find(f => f.field_name === "Watch Field Id");
              if (watchFieldId) {
                watchFieldId.field_selected_value = null;
              }
            });
          }
        } catch (error) {
          console.error("Error fetching form variables for CC_SC", error);
        } finally {
          dispatch(setLoading(false));
        }
      }
    } else if (
      updatedField.field_name === "Watch Field" &&
      componentState?.data?.form_name.includes(COMMUNICATION_CC_SC)
    ) {
      const selectedValue = updatedField.field_selected_value;
      const valToCheck = typeof selectedValue === "object" ? selectedValue?.value : selectedValue;
      const selectedOption = updatedField.field_value?.find(opt => opt.value === valToCheck);

      if (selectedOption) {
        newFields.forEach(pageFields => {
          const watchFieldId = pageFields.find(f => f.field_name === "Watch Field Id");
          if (watchFieldId) {
            watchFieldId.field_selected_value = selectedOption.id;
          }
        });
      }
    } else if (
      updatedField.field_name === "Target Uid Form" &&
      componentState?.data?.form_name.includes(COMMUNICATION_CC_SC)
    ) {
      const selectedValue = updatedField.field_selected_value;
      const valToCheck = typeof selectedValue === "object" ? selectedValue?.value : selectedValue;

      if (valToCheck === "null_value") {
        newFields.forEach(pageFields => {
          const usersField = pageFields.find(f => f.field_name === "Target Form Users");
          if (usersField) {
            usersField.field_type = "multiSelect";
            usersField.field_value = [];
            usersField.field_selected_value = null;
          }
          const targetUidFormIdField = pageFields.find(f => f.field_name === "Target Uid Form Id");
          if (targetUidFormIdField) {
            targetUidFormIdField.field_selected_value = null;
          }
        });
      } else {
        const selectedForm = tempList.find(f => f.form_name === valToCheck);
        if (selectedForm) {
          newFields.forEach(pageFields => {
            const targetUidFormIdField = pageFields.find(f => f.field_name === "Target Uid Form Id");
            if (targetUidFormIdField) {
              targetUidFormIdField.field_selected_value = selectedForm.id;
            }
          });

          try {
            dispatch(setLoading(true));
            const topicId = componentState?.projectData?.TopicID;
            const response = await getRecordsUidFields(topicId, selectedForm.id);
            const users = response?.data || [];
            const userOptions = users.map(user => ({
              label: user.field_selected_value,
              value: user.record_id,
              ...user
            }));

            newFields.forEach(pageFields => {
              const usersField = pageFields.find(f => f.field_name === "Target Form Users");
              if (usersField) {
                usersField.field_value = userOptions;

                if (usersField.field_selected_value) {
                  const currentSelections = Array.isArray(usersField.field_selected_value)
                    ? usersField.field_selected_value
                    : [usersField.field_selected_value];

                  const resolvedSelections = currentSelections.map(sel => {
                    const val = typeof sel === "object" ? sel.label || sel.value : sel;
                    return userOptions.find(opt => opt.label === val) || sel;
                  });

                  usersField.field_selected_value = resolvedSelections;

                  const usersIdField = pageFields.find(f => f.field_name === "Target Form Users Id");
                  if (usersIdField) {
                    usersIdField.field_selected_value = resolvedSelections.map(
                      s => s.record_id || s.value || s
                    );
                  }
                } else {
                  usersField.field_selected_value = null;
                }
              }
            });
          } catch (error) {
            console.error("Error fetching target form users for CC_SC", error);
          } finally {
            dispatch(setLoading(false));
          }
        }
      }
    } else if (
      updatedField.field_name === "Target Form Users" &&
      componentState?.data?.form_name.includes(COMMUNICATION_CC_SC)
    ) {
      const selectedValue = updatedField.field_selected_value;
      const ids = Array.isArray(selectedValue)
        ? selectedValue.map(item => item?.record_id || (item?.value ?? item))
        : [];

      newFields.forEach(pageFields => {
        const usersIdField = pageFields.find(f => f.field_name === "Target Form Users Id");
        if (usersIdField) {
          usersIdField.field_selected_value = ids;
        }
      });
    }

    //Always update state — no isChanged gate
    setFormFields(newFields);
  };


  useEffect(() => {
    let tempState = props?.data ? props : loc.state;
    setComponentState(tempState);
    if (tempState && tempState.moduleType === "dataEntry") {
      checkUserCredits(tempState);
      fetchRules(tempState?.data);
      setModuleType("dataEntry");
      setFormData(tempState.data);
      if (tempState?.modifyType === "modifyPartial") {
        const emptyFieldIds = tempState?.selectedValues?.filter((field) => !field?.field_selected_value).map((field) => field.id);
        setModifyPartialFieldIds(emptyFieldIds);
        setIsModifyPartial(true);
      }
      if (tempState?.selectedValues && tempState?.selectedValues.length > 0) {
        setIsModifyData(true);
      }

      if (tempState?.modifyType && modifyReasonTypes.includes(tempState?.modifyType)) {
        const uidFieldId = tempState?.selectedValues?.find((field) => field?.field_use_type?.includes("UID"))?.id;
        setDisabledFields((prevFields) => [...prevFields, uidFieldId]);
      }

      fetchFormData();
    } else {
      let url = window.location.href;
      setFormData(props?.formData);
      fetchRules(props?.formData);
      // Step 1: Prevent infinite loop
      if (!url.includes('nocache=')) {
        const separator = url.includes('?') ? '&' : '?';
        const cacheBustedUrl = `${url}${separator}nocache=${new Date().getTime()}`;
        window.location.href = cacheBustedUrl;
        return;
      }

      // Step 2: Parse query parameters
      const params = new URLSearchParams(window.location.search);
      const language = params.get('language');
      const formId = params.get('formId');
      const topicId = params.get('topicId');
      const uidFieldId = params.get("uidFieldId");
      const uidValue = params.get('uid');
      const nocache = params.get('nocache');

      // Check if already submitted from this browser
      const dssd = props.formData?.dssd || false;
      const dssd_number = props.formData?.dssd_number || 1;
      if (dssd) {
        const maxSubmissions = dssd_number || 1;
        const cookieValue = getCookie(`form_${formId}`);
        const count = cookieValue ? parseInt(cookieValue) : 0;
        if (count >= maxSubmissions) {
          setIsCurrentFormSubmitted(true);
          setCurrentFormSubmittedMessage("You have already submitted this form.");
          return;
        }
      }


      let lang = languagesData.find((item) => item.value == language);
      if (!lang) {
        lang = languagesData.find((item) => item.value === 'en');
      }
      setSelectedLanguage(lang);

      let lastParam = url.substring(url.lastIndexOf("&") + 1);
      let decodedParam = decodeURIComponent(lastParam);

      const processedFields = processFormFields(props?.formData?.form_fields);
      if (uidFieldId && uidValue) {
        const uidIndex = processedFields.findIndex((field) => field.id === uidFieldId);
        const isPrev = processedFields[uidIndex]?.field_type === "dropDownPreviousResponses";
        if (uidIndex !== -1) {
          processedFields[uidIndex].field_selected_value = isPrev
            ? { name: uidValue, label: uidValue, value: uidValue }
            : uidValue;
        }
        setFormFields([processedFields]);
        setDisabledFields((prevFields) => [...prevFields, uidFieldId]);
        setShouldProceed(true);
      } else {
        setFormFields([processedFields]);
      }
      fetchConfig(props?.formData?.id)
      let date = new Date();
      setFormStartTime(date);
    }
    localStorage.setItem("versionid", Date.now().toString());

  }, []);

  async function checkUserCredits(tempState: any) {
    try {
      dispatch(setLoading(true));
      const aiAgents: any = JSON.parse(localStorage.getItem("aiAgents") || "[]");
      const speechToTextAgent = aiAgents?.find((agent) => agent.name === "Speech to Text – Normal");
      const response: any = await fetchUserCredits(speechToTextAgent?.id, tempState?.projectData?.TopicID);
      if (response?.status) {
        setIsCreditsAvailable(true);
      } else {
        setIsCreditsAvailable(false);
      }
    } catch (error) {
      console.error(error);
    } finally {
      dispatch(setLoading(false));
    }
  }

  const updateFormFieldsInModify = (fFields) => {
    let temp: any = location.state;
    const updatedFormFields = fFields.map((field) => {
      const selectedValue = temp?.selectedValues?.find((item) => item.id === field.id);
      if (selectedValue) {
        if (field.field_type === "dropDown" || field.field_type === "dropDownPreviousResponses") {
          const rawVal = selectedValue.field_selected_value;
          field.field_selected_value = rawVal != null && rawVal !== ""
            ? { label: rawVal, value: rawVal }
            : null;
        } else if (field.field_type === "multiSelect" || field.field_type === "checkBox") {
          const values = Array.isArray(selectedValue.field_selected_value)
            ? selectedValue.field_selected_value
            : (selectedValue.field_selected_value != null && selectedValue.field_selected_value !== "")
              ? [selectedValue.field_selected_value]
              : [];

          if (field.field_type === "multiSelect") {
            field.field_selected_value = values.map((v) =>
              typeof v === "object" ? v : { label: v, value: v }
            );
          } else {
            field.field_selected_value = values;
          }
        } else {
          field.field_selected_value = selectedValue.field_selected_value;
        }
      }
      return field;
    });
    return updatedFormFields;
  }


  const fetchFormData = async () => {
    try {
      const temp: any = location.state;

      await fetchConfig(temp.data.id);

      const perData =
        projectDataPerm.projectPermissionData?.filter(
          itm => itm.projectId == temp.projectData.id
        ) || [];

      const permArray: any = {};
      perData[0]?.permissionData.forEach(obj => {
        const key = Object.keys(obj)[0];
        obj[key].forEach(objItem => {
          permArray[objItem.action] =
            objItem.permissions.find(p => p.title === "allowed")?.is_selected;
        });
      });

      setPermissionData(permArray);

      dispatch(setLoading(true));

      const response = await getNonSurveyForm(
        temp.data.id,
        permArray["all data view"]
      );

      let rawFields = cloneDeep(response?.data?.form_fields || []);

      if (temp?.modifyType === "searchIndexAutofill") {
        setAutofillFieldValues(temp.autofillData || []);

        const autofillMap = new Map<string, any>();

        (temp.autofillData || []).forEach(field => {
          autofillMap.set(field.id, field.field_selected_value);
        });
        rawFields = rawFields.map(field => {
          if (!autofillMap.has(field.id)) return field;

          const valueToCopy = autofillMap.get(field.id);
          if (valueToCopy === null || valueToCopy === undefined || valueToCopy === "")
            return field;

          return {
            ...field,
            field_selected_value: valueToCopy,
          };
        });
      }

      let finalFields = cloneDeep(rawFields);

      const tableViewData = response.data?.form_use_category?.includes("Allow Table Data Capture") || "";
      if (tableViewData) {
        response.data.isTable = [true];
        setTableFormData(getTableFormData());
        if (!temp?.modifyType || !["modify", "modifyPartial"].includes(temp.modifyType)) {
          setTableView(true);
        }
      } else {
        response.data.isTable = [false];
      }

      if (temp?.selectedValues?.length > 0) {
        const fieldsTobeModified = cloneDeep(finalFields);
        finalFields = updateFormFieldsInModify(fieldsTobeModified);
      }
      // Re-hide communication ID fields after modify populate
      if (temp?.data?.form_name.includes(COMMUNICATION_CC_PC)) {
        finalFields = finalFields.map(field => {
          if (["Form Id", "Field Id"].includes(field.field_name)) {
            return { ...field, is_hidden: true };
          }
          return field;
        });
      } else if (temp?.data?.form_name.includes(COMMUNICATION_CC_MSG_LK)) {
        finalFields = finalFields.map(field => {
          if (field.field_name === "Form Id") {
            return { ...field, is_hidden: true };
          }
          return field;
        });
      } else if (temp?.data?.form_name.includes(COMMUNICATION_CC_TC)) {
        finalFields = finalFields.map(field => {
          if (["Target Uid Form Id", "Target Form Users Id", "Target Data Collection Form Id"].includes(field.field_name)) {
            return { ...field, is_hidden: true };
          }
          return field;
        });
      } else if (temp?.data?.form_name.includes(COMMUNICATION_CC_SC)) {
        finalFields = finalFields.map(field => {
          if (["Schedule Form Id", "Watch Field Id", "Target Uid Form Id", "Target Form Users Id"].includes(field.field_name)) {
            return { ...field, is_hidden: true };
          }
          return field;
        });
      }

      const isMaster = temp?.data?.uidData && Object.keys(temp.data.uidData).length > 0;
      setIsMasterFlow(isMaster);
      response.data.isMaster = isMaster;
      setMasterUidData(temp?.data?.uidData);

      if (
        response.data.form_fields?.[response.data.form_fields.length - 1]
          ?.action_enabled ||
        !response.data.form_fields?.[0]?.field_use_type?.includes("identifier")
      ) {
        response.data.isActionEnabled = true;
      }

      response.data.form_fields = [response.data.form_fields];
      response.data.islocked = temp.data.locked;
      response.data.projectId = temp.projectData.id;
      response.data.projectData = temp.projectData;

      const parentTag = temp?.parentFormData?.parent_tag;
      if (parentTag) {
        const idx = finalFields.findIndex(field =>
          (field.field_use_type ?? "").includes("ParentTag")
        );
        if (idx !== -1) {
          finalFields[idx].field_selected_value = parentTag;
          setDisabledFields(prev => [...prev, finalFields[idx].id]);
        }
      }

      if (response.data.isMaster) {
        const uidValue = temp.data.uidData.field_selected_value;
        const uidFieldId = temp.data.uidData.id;

        let foundUidField = false;
        for (const field of finalFields) {
          const isUidField = (field.field_use_type ?? "").includes("UID");
          const isSameField = field.id === uidFieldId;

          if (isUidField && isSameField) {
            foundUidField = true;
            field.field_selected_value =
              field.field_type === "dropDown" ||
                field.field_type === "dropDownPreviousResponses"
                ? { label: uidValue, value: uidValue }
                : uidValue;

            setDisabledFields(prev => [...prev, field.id]);
            break;
          }
        }

        if (!foundUidField) {
          showToaster(toasterTypes.ERROR, `Cannot access ${temp?.data?.form_name} from ${temp?.parentFormData?.form_name}`, 4000);
          handleClose();
        }
      }


      const finalProcessedFields = processFormFields(finalFields) || [];
      setFormFields([finalProcessedFields]);

      //Trigger communication field sync for modify mode
      if (temp?.data?.form_name.includes(COMMUNICATION_CC_TC)) {
        const targetUidField = finalProcessedFields.find(f => f.field_name === "Target Uid Form");
        if (targetUidField && targetUidField.field_selected_value) {
          updateCommunicationFields(targetUidField, [finalProcessedFields]);
        }
      } else if (temp?.data?.form_name.includes(COMMUNICATION_CC_SC)) {
        const targetUidField = finalProcessedFields.find(f => f.field_name === "Target Uid Form");
        if (targetUidField && targetUidField.field_selected_value) {
          updateCommunicationFields(targetUidField, [finalProcessedFields]);
        }
      }

      if (response.data.isMaster) {
        const isAllFieldsFilled = finalProcessedFields.every(field => {
          if (field.field_type === "checkBox") {
            return (
              Array.isArray(field.field_selected_value) &&
              field.field_selected_value.length > 0
            );
          }
          return (
            field.field_selected_value !== null &&
            field.field_selected_value !== ""
          );
        });

        if (isAllFieldsFilled) {
          next({ currentFormFields: [finalProcessedFields] });
        }
      }
    } catch (error) {
      console.error("Error fetching form data:", error);
    } finally {
      dispatch(setLoading(false));
    }
  };


  /**
     * fetch form config data
     */
  const fetchConfig = async (id) => {
    try {
      let response = await getVarConfig(id);
      setConfigData(response && response.data)
      return response.data
    } catch (error) {

    }
  }

  /**
     * 
     * @param name 
     * @param value 
     * @param values 
     * @param fieldValues 
     * @returns 
     */
  function onValueChange(name, value, values, fieldValues = null) {
    const tempFormFields: any = cloneDeep(formFields);
    const fieldIndex = tempFormFields[page].findIndex((field) => field.id === name);
    const originalField = tempFormFields[page][fieldIndex];

    const updatedField = {
      ...originalField,
      field_selected_value: value,
      localized_field_selected_value: value,
      data_entry_language: selectedLanguage.value,
    };

    const updatedFormFields = [...formFields];
    updatedFormFields[page] = [...updatedFormFields[page]];
    updatedFormFields[page][fieldIndex] = updatedField;

    const isCommunicationForm =
      componentState?.data?.form_name.includes(COMMUNICATION_CC_PC) ||
      componentState?.data?.form_name.includes(COMMUNICATION_CC_TC) ||
      componentState?.data?.form_name.includes(COMMUNICATION_CC_MSG_LK) ||
      componentState?.data?.form_name.includes(COMMUNICATION_CC_SC);

    if (isCommunicationForm) {
      //Let updateCommunicationFields own the state update entirely
      updateCommunicationFields(updatedField, updatedFormFields);
    } else {
      setFormFields(updatedFormFields);
    }

    if (["dateField", "radioButton", "dropDown", "signatureCapture", "time", "multiSelect"]
      .includes(updatedField.field_type)) {
      handleOnBlur(updatedField, fieldIndex, updatedFormFields);
    }

    if (updatedField.field_type === "dropDownPreviousResponses") {
      const lastField = formFields[page].at(-1);
      if (lastField.id === updatedField.id) {
        handleOnBlur(updatedField, fieldIndex, updatedFormFields);
      }
    }

    if (["dateTime"].includes(updatedField.field_type)) {
      checkValidationAndAutofill(updatedField, fieldIndex, updatedFormFields);
      return;
    }
  }

  function handleOnBlur(field, index, currentFormFields) {
    checkValidationAndAutofill(field, index, currentFormFields);
    const isActionEnabled = field.action_enabled;
    const isUidField = field.field_type === "dropDownPreviousResponses";
    const isSearchIndex = field.field_use_type.includes("SearchIndex");
    if (isActionEnabled || (isUidField && !isSearchIndex) || (noMoreFields && index === currentFormFields[page].length - 1)) {
      next({ currentFormFields });
    }
  }


  function getValues(data, type) {
    const valuesData: any[] = [];
    if (type === "prev") {
      data.forEach(item => {
        valuesData.push({
          label: item.value,
          value: item.value
        });
      });
    } else {
      data.forEach(item => {
        valuesData.push({
          label: item,
          value: item
        });
      });
    }
    return valuesData;
  }

  const isAlreadyOptionObject = (val: any) => {
    return (
      val &&
      typeof val === "object" &&
      val.label !== undefined &&
      val.value !== undefined
    );
  };

  const normalizeSelectedValue = (value, fieldType) => {
    if (fieldType === "checkBox") {
      if (Array.isArray(value)) return value;
      if (value === "" || value === null) return [];
      return [value];
    }

    if (value == null) return value;

    const needsPrev = fieldType === "dropDownPreviousResponses";

    const toOption = (val) => ({
      label: needsPrev ? val.value ?? val : val,
      value: needsPrev ? val.value ?? val : val
    });

    if (Array.isArray(value)) {
      if (value.length > 0 && isAlreadyOptionObject(value[0])) {
        return value;
      }
      return value.map(v => toOption(v));
    }

    // Single value
    if (isAlreadyOptionObject(value)) {
      return value;
    }

    return toOption(value);
  };



  function processFormFields(formFieldsData) {
    return formFieldsData.map(field => {
      const shouldTransform =
        field.field_type === "dropDown" ||
        field.field_type === "radioButton" ||
        field.field_type === "checkBox" ||
        field.field_type === "multiSelect";

      const needsPrev = field.field_type === "dropDownPreviousResponses";
      const type = needsPrev ? "prev" : "";

      const safeGetValues = (values, type = "") => {
        if (!Array.isArray(values)) return values;

        if (values.length > 0 && isAlreadyOptionObject(values[0])) {
          return values;
        }

        return getValues(values, type);
      };

      const shouldNormalizeSelected =
        field.field_type === "dropDown" ||
        field.field_type === "dropDownPreviousResponses" ||
        field.field_type === "checkBox";

      const processedSelectedValue = field.field_type === "time" && field.field_selected_value
        ? convertUTCTimeToIST(field.field_selected_value)
        : shouldNormalizeSelected
          ? normalizeSelectedValue(field.field_selected_value, field.field_type)
          : field.field_selected_value;

      return {
        ...field,

        field_value:
          shouldTransform || needsPrev
            ? safeGetValues(field.field_value || [], type)
            : field.field_value,

        field_selected_value: processedSelectedValue,

        localized_field_selected_value: null,
        data_entry_language: selectedLanguage.value || "en",

        localized:
          field.localized?.map(loc => ({
            ...loc,
            localized_field_value: shouldTransform
              ? safeGetValues(loc.localized_field_value || [])
              : loc.localized_field_value,
            localized_field_row_value: shouldTransform
              ? safeGetValues(loc.localized_field_row_value || [])
              : loc.localized_field_row_value
          })) || []
      };
    });
  }


  const getFieldsGroupedByCategory = (pageFields) => {
    const grouped = {};
    pageFields.forEach(field => {
      const category = field.field_category?.trim() || "Uncategorized";
      if (!grouped[category]) {
        grouped[category] = [];
      }
      grouped[category].push(field);
    });
    return grouped;
  };

  /**
         * fetch list of rules for the selected form
         */
  const fetchRules = async (fData) => {
    try {
      let response = await getRules(fData?.id);
      setRules(response && response.data)
    } catch (error) {

    }
  }

  const addAutoFilledFieldsToDisabledFields = (ruleString) => {
    const match = ruleString.match(/[a-f0-9]{24}/);
    const firstId: string = match ? match[0] : null;

    if (firstId) {
      setDisabledFields((prev) => {
        // Check if the ID already exists
        if (!prev.includes(firstId)) {
          return [...prev, firstId]; // Add new ID
        }
        return prev; // Leave as-is
      });
    }
  }

  const validateRules = (field, index, currentFormFields) => {
    let hasAnyError = false;
    let errorObj = "";
    const matchedRules = (rules || []).filter(rule => rule.includes(field.id));
    if (!matchedRules.length) return;

    // Create a shallow copy of the formFields with cloned section (page) only
    const updatedFormFields = currentFormFields.map((section, i) =>
      i === page ? [...section] : section
    );

    // Helper: Find field and return section + index
    const findFieldInfo = (id) => {
      for (let secIndex = 0; secIndex < updatedFormFields.length; secIndex++) {
        const fieldIndex = updatedFormFields[secIndex].findIndex(f => f.id === id);
        if (fieldIndex !== -1) {
          return {
            sectionIndex: secIndex,
            fieldIndex,
            field: updatedFormFields[secIndex][fieldIndex],
          };
        }
      }
      return null;
    };

    matchedRules.forEach((rawRule) => {
      const ruleString = rawRule.split("endrule")[0];
      const [ruleType, targetId, ruleExpr, ruleError] = ruleString.split(":").map(s => s.trim());
      const tokens = ruleExpr?.split(/( )/) || [];
      // ========== Validation Rule ==========
      if (ruleType === "validationrule" && targetId === field.id) {
        let formulaString = "";

        tokens.forEach(token => {
          const match = findFieldInfo(token);
          const targetField = match?.field;
          if (targetField) {
            const val = targetField.field_selected_value;
            if (targetField.field_type === "number") {
              formulaString += parseFloat(`${val}`);
            } else if (["dateField", "dateTime"].includes(targetField.field_type)) {
              formulaString += `new Date('${val}').getTime()`;
            } else {
              formulaString += `'${val}'`;
            }
          } else {
            formulaString += token === "currentdate" ? `+new Date().getTime()` : token;
          }
        });
        try {
          const isValid = eval(formulaString);
          if (!isValid) {
            errorObj = ruleError?.replace(/'/g, "") || "Validation error";
            hasAnyError = true;
          }
          updateError(index, {
            hasError: !!errorObj,
            errorMsg: errorObj,
          });
        } catch (err) {
          console.error("Error in validation eval:", err);
        }
      }

      // ========== Autofill Rule ==========
      if (ruleType === "autofillrule") {
        addAutoFilledFieldsToDisabledFields(targetId);
        let formulaString = "";

        tokens.forEach(token => {
          const match = findFieldInfo(token);
          const targetField = match?.field;
          if (targetField) {
            const val = targetField.field_selected_value;
            if (typeof val === "object") {
              formulaString += targetField.field_type === "dateField"
                ? `'${val}'`
                : `'${val?.label || ''}'`;
            } else {
              const localVal = processFieldValue(targetField, val, 'en');
              formulaString += `'${localVal.englishFieldValue || ''}'`;
            }
          } else {
            formulaString += token;
          }
        });

        let output;
        const functionName = formulaString.split('(')[0].trim();

        try {
          if (ruleExpr.includes(functionName) && typeof formula[functionName] === "function") {
            const args = formulaString.match(/\((.*)\)/)?.[1]?.trim();
            if (args) {
              output = formula[functionName](args);
            } else {
              errorObj = ruleError?.replace(/'/g, "") || "Autofill error";
            }
          } else {
            output = eval(formulaString);
          }

          const match = findFieldInfo(targetId);
          if (match) {
            const { sectionIndex, fieldIndex, field: originalField } = match;

            // Clone the field before modifying
            const updatedField = {
              ...originalField,
              field_selected_value: output,
              localized_field_selected_value: output,
              data_entry_language: 'en',
            };
            const { englishFieldValue, localizedFieldValue } = processFieldValue(updatedField, output, selectedLanguage.value);
            updatedFormFields[sectionIndex][fieldIndex] = {
              ...updatedField,
              field_selected_value: englishFieldValue,
              localized_field_selected_value: localizedFieldValue,
            };
          }
          if (errorObj) hasAnyError = true;
          updateError(index, {
            hasError: !!errorObj,
            errorMsg: errorObj,
          });

        } catch (err) {
          console.error("Error in autofill eval:", err);
        }
      }
    });
    setFormFields(updatedFormFields);
    return hasAnyError;
  };

  /**
  * validate fields on frontend or backend depending on the field type
  * @param obj 
  * @param validate 
  * @param selectedValue 
  */
  const checkValidation = async (field, index) => {
    const errorObj: any[] = [];
    const validations = field?.validations || [];
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    const numberRegex = /^(\+91[\-\s]?|91[\-\s]?|0)?[6-9]\d{9}$/;

    for (const rule of validations) {
      if (rule.startsWith('FE')) {
        const value = field.field_selected_value;
        switch (rule) {
          case "FE-EmailFormat":
            if (value?.length) {
              const isValid = emailRegex.test(value.trim());
              errorObj.push({
                name: index,
                data: {
                  hasError: !isValid,
                  errorMsg: !isValid ? 'Please enter valid Email' : ''
                }
              });
            }
            break;

          case "FE-Integer":
            const isInteger = Number(value) === Math.floor(Number(value));
            errorObj.push({
              name: index,
              data: {
                hasError: !isInteger,
                errorMsg: !isInteger ? 'Please enter valid integer' : ''
              }
            });
            break;

          case "FE-MobileNumber":
            const stringVal = typeof value === 'string' ? value : String(value);
            if (!stringVal || stringVal.trim() === "") {
              errorObj.push({
                name: index,
                data: {
                  hasError: true,
                  errorMsg: 'Mobile number cannot be empty'
                }
              });
              updateError(index, { hasError: true, errorMsg: 'Mobile number cannot be empty' });
            } else if (!numberRegex.test(value)) {
              errorObj.push({
                name: index,
                data: {
                  hasError: true,
                  errorMsg: 'Please enter a valid Mobile number'
                }
              });
              updateError(index, { hasError: true, errorMsg: 'Please enter a valid Mobile number' });
            }
            break;

          case "FE-Mandatory":
            if (field.field_type === 'radioButtonGrid') {
              if (value && value?.length !== field?.field_row_value?.length) {
                errorObj.push({
                  name: index,
                  data: {
                    hasError: true,
                    errorMsg: 'Please Fill all the rows'
                  }
                });
              }
            }
            if (!value || value === 'undefined') {
              errorObj.push({
                name: index,
                data: {
                  hasError: true,
                  errorMsg: 'Field cannot be empty'
                }
              });
            }
            break;
          case "FE-Range":
            const min = field.field_min_value;
            const max = field.field_max_value;
            const numValue = parseFloat(value);
            if (value?.length && (numValue < min || numValue > max)) {
              errorObj.push({
                name: index,
                data: {
                  hasError: true,
                  errorMsg: `Values should be between ${min} to ${max}`
                }
              });
            }
            break;
          default:
            updateError(index, { hasError: false, errorMsg: "" });
            break;
        }

      } else if (rule.startsWith('BE')) {
        const versionid: number = Number(localStorage.getItem("versionid"));
        let recordId = location.state?.id || "";
        if (!location.state?.id) {
          recordId = props?.data?.recordId || ""
        }
        const rawValue = field.field_selected_value;

        // Unwrap { label, value } objects (e.g. dropDown / dropDownPreviousResponses)
        const resolvedValue =
          rawValue !== null &&
            typeof rawValue === 'object' &&
            !Array.isArray(rawValue) &&
            'value' in rawValue
            ? rawValue.value
            : rawValue;

        const resObj = {
          field_id: field.id,
          value: resolvedValue,
          version_id: versionid,
          record_id: recordId,
        };

        if (resolvedValue !== null && resolvedValue !== undefined && String(resolvedValue).trim() !== "") {
          try {
            const formId = formData?.id || location.state?.data?.id || "";
            const modType = location.state?.modifyType || props?.moduleType === "surveyForm" || "";
            let res: any;
            if (props?.moduleType === "surveyForm") {
              res = await validateSurveyForm(formId, [resObj]);
            } else {
              res = await validateForm(formId, [resObj]);
            }

            if (!res?.success) {
              errorObj.push({
                name: index,
                data: {
                  hasError: true,
                  errorMsg: res?.error[0] || "Value already used"
                }
              });
            } else {
              errorObj.push({
                name: index,
                data: {
                  hasError: false,
                  errorMsg: ""
                }
              });
            }
          } catch {
            updateError(index, { hasError: true, errorMsg: "Value already used" });
          }
        }
      }
    }

    //check for uid field and skip action fields mandatory

    const isUidField = field?.field_use_type.includes("UID");
    const skipActionField = !!field?.action_enabled;
    const value = field.field_selected_value;
    if (field.field_type !== "instruction" && (isUidField || (skipActionField && !noMoreFields)) && !value) {
      errorObj.push({
        name: index,
        data: {
          hasError: true,
          errorMsg: `Please Fill the Required Field action feld maybe`
        }
      });
    }

    return errorObj;
  };

  const checkAllValidation = async (currentFormFields) => {
    let errorList: any[] = [];
    const tempFormFields = cloneDeep(currentFormFields);
    for (let i = 0; i < tempFormFields[page]?.length; i++) {
      const field = tempFormFields[page][i];
      const errors = await checkValidation(field, i);
      errorList.push(...errors);
    }
    if (errorList.length === 0) {
      removeErrors();
    } else {
      updateAllError(errorList);
    }

    return !errorList.some(item => item.data.hasError);
  };


  const checkValidationAndAutofill = async (field, index, currentFormFields) => {
    const errors = await checkValidation(field, index);
    if (errors.length === 0) {
      removeErrors(index);
    } else {
      updateAllError(errors);
    }
    const isValid = !errors.some(item => item.data.hasError);
    if (!isValid) return;
    validateRules(field, index, currentFormFields);
  };

  const getFieldIdAndAnswer = (currentFormFields) => {
    const tempFormFields = cloneDeep(currentFormFields);       // avoid mutation
    const fieldIds: string[] = [];
    const answers: (string | number)[] = [];

    tempFormFields.forEach(fieldGroup => {
      fieldGroup.forEach(field => {
        const valueObj: any = processFieldValue(field, field.field_selected_value, 'en');
        const selectedValue = valueObj?.englishFieldValue;

        fieldIds.push(field.id);   // always include the id

        let valueToAdd: string | number = '';

        if (selectedValue !== undefined && selectedValue !== null && selectedValue !== '') {
          if (field.field_type === 'number') {
            valueToAdd = parseInt(selectedValue as string, 10);
          } else if (
            field.field_type === 'dropDown' ||
            field.field_type === 'dropDownPreviousResponses'
          ) {
            valueToAdd = (selectedValue as any)?.value ?? '';
          } else {
            valueToAdd = selectedValue as string;
          }
        }
        answers.push(valueToAdd);
      });
    });

    return {
      fieldId: fieldIds.join(','),   // e.g. "id1,id2,id3"
      answer: answers.join(',')      // e.g. "42,,answer3"
    };
  };


  /**
    * on click previous erase all next data 
    * @returns 
    */
  async function previous() {
    const newPageNo = page - 1;
    setNoMoreFields(false);
    removeErrors()
    setFormFields(prevFields => prevFields.slice(0, -1));
    setPage(prev => prev - 1);
    setTableView(false);
  }

  const applyAutofillToFields = (fields: any[][], autofillData: any[]) => {
    if (!autofillData || autofillData.length === 0) return fields;

    const autofillMap = new Map<string, any>();
    autofillData.forEach((f: any) =>
      autofillMap.set(f.id, f.field_selected_value)
    );
    return fields.map(section =>
      section.map((field: any) => {
        if (!autofillMap.has(field.id)) return field;

        const valueToCopy = autofillMap.get(field.id);
        if (valueToCopy === null || valueToCopy === undefined || valueToCopy === "")
          return field;

        return {
          ...field,
          field_selected_value: valueToCopy,
        };
      })
    );
  };


  /**
     * on click next verify the data and call getData function call for next question
     * @returns 
     */
  async function next(
    {
      currentFormFields = [],
      getBackData = false,
    }: { currentFormFields?: any[][]; getBackData?: boolean } = {}
  ) {
    const endTime = new Date();

    // ALWAYS work on cloned data
    let workingFormFields =
      currentFormFields.length > 0
        ? cloneDeep(currentFormFields)
        : cloneDeep(formFields || []);

    removeErrors();

    // Validate current page
    workingFormFields[page]?.forEach((field, index) => {
      validateRules(field, index, workingFormFields);
    });

    const isValid = await checkAllValidation(workingFormFields);
    if (!isValid) {
      showToaster(toasterTypes.ERROR, "Please fill all the required fields.");
      return;
    }

    const isErrors = Object.values(fields).some(
      (field: any) => field.hasError
    );
    if (isErrors) return;

    const currentPageLastField =
      workingFormFields[page]?.[workingFormFields[page].length - 1];

    const lastFieldValidation = validateRules(
      currentPageLastField,
      workingFormFields[page].length - 1,
      workingFormFields
    );

    if (lastFieldValidation) {
      showToaster(toasterTypes.ERROR, "Please correct the errors.");
      return;
    }

    const tempState = location.state;
    const moduletype = moduleType || tempState?.moduleType;

    try {
      dispatch(setLoading(true));

      let response: any;

      const lastSection = workingFormFields.at(-1);
      const finalLastField = lastSection?.at(-1);
      const isActionEnabled = finalLastField?.action_enabled;

      if (isActionEnabled || !noMoreFields) {
        const { fieldId, answer } = getFieldIdAndAnswer(workingFormFields);

        if (moduletype === "dataEntry") {
          response = await fetchNextVariable(
            formData?.id || tempState?.data?.id,
            fieldId,
            answer,
            permissionData["all data view"]
          );
        } else {
          response = await getNextQuestion(
            formData?.id,
            fieldId,
            answer
          );
        }
      } else {
        setIsSubmit(true);
        setSubmitMessage(
          response?.message ||
          "There are no more actions as per the answers submitted."
        );
        return;
      }

      if (response?.success && response?.data) {
        setNoMoreFields(response?.no_more_fields);

        if (response?.view_type === "Allow Table Data Capture") {
          setTableFormData(getTableFormData());
          const tempState = location.state;
          if (!tempState?.modifyType || !["modify", "modifyPartial"].includes(tempState.modifyType)) {
            setTableView(true);
          }
        } else {
          setTableView(false);
        }

        let nextPageFields = response.data;
        if (isModifyData) {
          nextPageFields = updateFormFieldsInModify(nextPageFields);
        }
        nextPageFields = processFormFields(nextPageFields);
        const updatedFormFields = applyAutofillToFields(
          [...workingFormFields, nextPageFields],
          autofillFieldValues
        );

        if (getBackData) {
          return updatedFormFields;
        }

        setPage(prev => prev + 1);
        scrollToTop();
        setFormFields(updatedFormFields);

        // Trigger communication field sync for newly fetched page fields
        const tempState = location.state;
        if (
          tempState?.data?.form_name.includes(COMMUNICATION_CC_TC) ||
          tempState?.data?.form_name.includes(COMMUNICATION_CC_PC)
        ) {
          const targetUidField = nextPageFields.find(f => f.field_name === "Target Uid Form");
          if (targetUidField && targetUidField.field_selected_value) {
            updateCommunicationFields(targetUidField, updatedFormFields);
          }

          const formNameField = nextPageFields.find(f => f.field_name === "Form Name");
          if (formNameField && formNameField.field_selected_value) {
            updateCommunicationFields(formNameField, updatedFormFields);
          }
        } else if (tempState?.data?.form_name.includes(COMMUNICATION_CC_SC)) {
          const targetUidField = nextPageFields.find(f => f.field_name === "Target Uid Form");
          if (targetUidField && targetUidField.field_selected_value) {
            updateCommunicationFields(targetUidField, updatedFormFields);
          }
        }
      } else {
        if (getBackData) {
          return workingFormFields;
        }
        setIsSubmit(true);
        setSubmitMessage(
          response?.message ||
          "There are no more actions as per the answers submitted."
        );
      }
    } catch (error) {
      console.error(error);
    } finally {
      dispatch(setLoading(false));
    }
  }

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  const uploadDoc = async (data, resolve, reject) => {
    try {
      dispatch(setLoading(true));
      let response = await uploadPhoto(data);
      if (response.mediaUrl) {
        resolve(response.mediaUrl);
      }
      dispatch(setLoading(false));
    } catch (e: any) {
      reject('');
      dispatch(setLoading(false));
    }
  }

  const processFieldScores = (field: any, value: any) => {
    if (!value || !field.field_values_scores || field.field_values_scores.length === 0) {
      return null;
    }
    let totalScore = 0;
    const colCount = field.field_value?.length || 0;

    switch (field.field_type) {
      case "number":
      case "textBox": {
        const parser = new Parser();
        const expression = parser.parse(field.field_values_scores);
        const context = {
          variable: Number(field.field_selected_value)
        };
        const score = expression.evaluate(context);
        totalScore = score;
        break;
      }
      case "radioButton": {
        const index = field.field_value.findIndex(item => item.value === value);
        if (index !== -1) {
          const score = field.field_values_scores[index] || 0;
          totalScore += score;
        }
        break;
      }

      case "dropDown": {
        const index = field.field_value.findIndex(item => {
          if (typeof value === "object") {
            return item.label === value.label && item.value === value.value;
          }
          return item.value === value;
        });
        if (index !== -1) {
          const score = field.field_values_scores[index] || 0;
          totalScore += score;
        }
        break;
      }

      case "multiSelect":
      case "checkBox": {
        if (!Array.isArray(value)) break;
        value.forEach((val: any) => {
          const selectionValue = (typeof val === 'object' && val !== null) ? (val.value ?? val) : val;
          const index = field.field_value.findIndex(item => {
            const itemVal = (typeof item === 'object' && item !== null) ? (item.value ?? item) : item;
            return itemVal === selectionValue;
          });
          if (index !== -1) {
            const score = field.field_values_scores[index] || 0;
            totalScore += score;
          }
        });
        break;
      }

      case "checkBoxGrid":
      case "radioButtonGrid": {
        value.forEach((item: any) => {
          const rowIndex = field.field_row_value.findIndex(row => row === item.rowKey);

          if (field.field_type === "radioButtonGrid") {
            const colIndex = field.field_value.findIndex(col => col === item.value);
            if (rowIndex !== -1 && colIndex !== -1) {
              const index = rowIndex * colCount + colIndex;
              const score = field.field_values_scores[index] || 0;
              totalScore += score;
            }
          } else {
            item.value.forEach((colVal: any) => {
              const colIndex = field.field_value.findIndex(col => col === colVal || col.value === colVal || col.label === colVal);
              if (rowIndex !== -1 && colIndex !== -1) {
                const index = rowIndex * colCount + colIndex;
                const score = field.field_values_scores[index] || 0;
                totalScore += score;
              }
            });
          }
        });
        break;
      }

      default:
        break;
    }

    // field.field_selected_value_score = totalScore;
    return totalScore;
  };

  const processFieldValue = (field: any, value, targetLanguage) => {
    // Handle null/undefined values
    if (value === null || value === undefined) {
      return {
        englishFieldValue: null,
        localizedFieldValue: null
      };
    }

    // Handle empty arrays for grid fields
    if (!value && gridFields.includes(field.field_type)) {
      return {
        englishFieldValue: [],
        localizedFieldValue: []
      };
    }

    // Handle empty strings or other falsy values
    if (!value) {
      return {
        englishFieldValue: value,
        localizedFieldValue: value
      };
    }

    // If field is not localized, return the value as is
    if (["dateField", "dateTime"].includes(field.field_type)) {
      const parsed = dayjs(value);

      if (!value || !parsed.isValid()) {
        return {
          englishFieldValue: null,
          localizedFieldValue: null
        };
      }

      const isoDate = parsed.toISOString();
      return {
        englishFieldValue: isoDate,
        localizedFieldValue: isoDate
      };
    }

    if (!field.is_localized) {
      return {
        englishFieldValue: value,
        localizedFieldValue: value
      };
    }


    // Handle English target language - use field.field_value directly
    if (targetLanguage === 'en') {
      // If data was entered in English, return as is
      if (field.data_entry_language === 'en') {
        return {
          englishFieldValue: value,
          localizedFieldValue: value
        };
      }
      // If data was entered in another language, we need to convert to English
      // This will be handled in the switch cases below with targetLocalization = null
    }

    // Find the target language localization (will be null for English)
    const targetLocalization = targetLanguage === 'en' ? null : field.localized.find(loc => loc.language === targetLanguage);

    // If target language is not English and no localization found, return original values
    if (targetLanguage !== 'en' && (!targetLocalization || !targetLocalization.localized_field_value)) {
      return {
        englishFieldValue: value,
        localizedFieldValue: value
      };
    }

    // Find the data entry language localization to get the mapping
    const dataEntryLocalization = field.localized.find(loc => loc.language === field.data_entry_language);

    let targetFieldValue = value;
    let englishFieldValue = value;

    switch (field.field_type) {
      case "radioButton": {
        // Find index based on data entry language
        let sourceIndex = -1;
        if (field.data_entry_language === 'en') {
          sourceIndex = field.field_value.findIndex(item => item.value === value);
        } else if (dataEntryLocalization) {
          sourceIndex = dataEntryLocalization.localized_field_value.findIndex(item => item.value === value);
        }

        if (sourceIndex !== -1) {
          englishFieldValue = field.field_value[sourceIndex].value;
          // If target is English, use English value, otherwise use target localization
          targetFieldValue = targetLanguage === 'en' ?
            field.field_value[sourceIndex].value :
            targetLocalization.localized_field_value[sourceIndex]?.value || value;
        }
        break;
      }

      case "dropDown": {
        let sourceIndex = -1;
        if (field.data_entry_language === 'en') {
          sourceIndex = field.field_value.findIndex(item => {
            if (typeof value === "object") {
              return item.label === value.label && item.value === value.value;
            }
            return item.value === value;
          });
        } else if (dataEntryLocalization) {
          sourceIndex = dataEntryLocalization.localized_field_value.findIndex(item => {
            if (typeof value === "object") {
              return item.label === value.label && item.value === value.value;
            }
            return item.value === value;
          });
        }

        if (sourceIndex !== -1) {
          englishFieldValue = field.field_value[sourceIndex];
          // If target is English, use English value, otherwise use target localization
          targetFieldValue = targetLanguage === 'en' ?
            field.field_value[sourceIndex] :
            targetLocalization.localized_field_value[sourceIndex] || value;
        }
        break;
      }

      case "checkBox": {
        // Handle null or empty array
        if (!Array.isArray(value) || value.length === 0) {
          englishFieldValue = [];
          targetFieldValue = [];
          break;
        }

        const targetSelected: any = [];
        const englishSelected: any = [];

        value.forEach((val: any) => {
          let sourceIndex = -1;
          if (field.data_entry_language === 'en') {
            sourceIndex = field.field_value.findIndex(item => item.value === val);
          } else if (dataEntryLocalization) {
            sourceIndex = dataEntryLocalization.localized_field_value.findIndex(item => item.value === val);
          }

          if (sourceIndex !== -1) {
            englishSelected.push(field.field_value[sourceIndex].value);
            // If target is English, use English value, otherwise use target localization
            targetSelected.push(targetLanguage === 'en' ?
              field.field_value[sourceIndex].value :
              targetLocalization.localized_field_value[sourceIndex]?.value || val);
          } else {
            englishSelected.push(val);
            targetSelected.push(val);
          }
        });

        englishFieldValue = englishSelected;
        targetFieldValue = targetSelected;
        break;
      }

      case "multiSelect": {
        // Handle null or empty array
        if (!Array.isArray(value) || value.length === 0) {
          englishFieldValue = [];
          targetFieldValue = [];
          break;
        }

        const targetSelected: any = [];
        const englishSelected: any = [];

        value.forEach((val: any) => {
          let selectionValue = (typeof val === 'object' ? val.value : val);
          let sourceIndex = -1;

          if (field.data_entry_language === 'en') {
            sourceIndex = field.field_value?.findIndex(item => {
              const itemVal = (typeof item === 'object' ? item.value : item);
              return itemVal === selectionValue;
            });
          } else if (dataEntryLocalization) {
            sourceIndex = dataEntryLocalization.localized_field_value?.findIndex(item => {
              const itemVal = (typeof item === 'object' ? item.value : item);
              return itemVal === selectionValue;
            });
          }

          if (sourceIndex !== -1) {
            const englishItem = field.field_value[sourceIndex];
            const englishVal = (typeof englishItem === 'object' ? englishItem.value : englishItem);
            englishSelected.push({ label: englishVal, value: englishVal });

            // If target is English, use English value, otherwise use target localization
            if (targetLanguage === 'en') {
              targetSelected.push({ label: englishVal, value: englishVal });
            } else {
              const targetItem = targetLocalization.localized_field_value[sourceIndex];
              const targetVal = (typeof targetItem === 'object' ? targetItem.value : targetItem) || selectionValue;
              targetSelected.push({ label: targetVal, value: targetVal });
            }
          } else {
            englishSelected.push({ label: selectionValue, value: selectionValue });
            targetSelected.push({ label: selectionValue, value: selectionValue });
          }
        });

        englishFieldValue = englishSelected;
        targetFieldValue = targetSelected;
        break;
      }

      case "checkBoxGrid": {
        // Handle null or empty array
        if (!Array.isArray(value) || value.length === 0) {
          englishFieldValue = [];
          targetFieldValue = [];
          break;
        }

        const targetSelected: any = [];
        const englishSelected: any = [];

        value.forEach(item => {
          // Handle row mapping
          let rowIndex = -1;
          if (field.data_entry_language === 'en') {
            rowIndex = field.field_row_value.findIndex(row => row === item.rowKey);
          } else if (dataEntryLocalization) {
            rowIndex = dataEntryLocalization.localized_field_row_value.findIndex(row => row === item.rowKey);
          }

          const englishRowKey = rowIndex !== -1 ? field.field_row_value[rowIndex] : item.rowKey;
          const targetRowKey = targetLanguage === 'en' ?
            englishRowKey :
            (rowIndex !== -1 ? targetLocalization.localized_field_row_value[rowIndex] : item.rowKey);

          // Handle column mapping
          const englishCols: any = [];
          const targetCols: any = [];

          item.value.forEach(colVal => {
            let colIndex = -1;
            if (field.data_entry_language === 'en') {
              colIndex = field.field_value.findIndex(col => col === colVal);
            } else if (dataEntryLocalization) {
              colIndex = dataEntryLocalization.localized_field_value.findIndex(col => col === colVal);
            }

            const englishCol = colIndex !== -1 ? field.field_value[colIndex] : colVal;
            const targetCol = targetLanguage === 'en' ?
              englishCol :
              (colIndex !== -1 ? targetLocalization.localized_field_value[colIndex] : colVal);

            englishCols.push(englishCol);
            targetCols.push(targetCol);
          });

          englishSelected.push({ rowKey: englishRowKey, value: englishCols });
          targetSelected.push({ rowKey: targetRowKey, value: targetCols });
        });

        englishFieldValue = englishSelected;
        targetFieldValue = targetSelected;
        break;
      }

      case "radioButtonGrid": {
        // Handle null or empty array
        if (!Array.isArray(value) || value.length === 0) {
          englishFieldValue = [];
          targetFieldValue = [];
          break;
        }

        const targetSelected: any = [];
        const englishSelected: any = [];

        value.forEach(item => {
          // Handle row mapping
          let rowIndex = -1;
          if (field.data_entry_language === 'en') {
            rowIndex = field.field_row_value.findIndex(row => row === item.rowKey);
          } else if (dataEntryLocalization) {
            rowIndex = dataEntryLocalization.localized_field_row_value.findIndex(row => row === item.rowKey);
          }

          // Handle column mapping
          let colIndex = -1;
          if (field.data_entry_language === 'en') {
            colIndex = field.field_value.findIndex(col => col === item.value);
          } else if (dataEntryLocalization) {
            colIndex = dataEntryLocalization.localized_field_value.findIndex(col => col === item.value);
          }

          const englishRowKey = rowIndex !== -1 ? field.field_row_value[rowIndex] : item.rowKey;
          const englishColVal = colIndex !== -1 ? field.field_value[colIndex] : item.value;

          const targetRowKey = targetLanguage === 'en' ?
            englishRowKey :
            (rowIndex !== -1 ? targetLocalization.localized_field_row_value[rowIndex] : item.rowKey);
          const targetColVal = targetLanguage === 'en' ?
            englishColVal :
            (colIndex !== -1 ? targetLocalization.localized_field_value[colIndex] : item.value);

          englishSelected.push({ rowKey: englishRowKey, value: englishColVal });
          targetSelected.push({ rowKey: targetRowKey, value: targetColVal });
        });

        englishFieldValue = englishSelected;
        targetFieldValue = targetSelected;
        break;
      }

      case "textBoxGrid": {
        // Handle null or empty array
        if (!Array.isArray(value) || value.length === 0) {
          englishFieldValue = [];
          targetFieldValue = [];
          break;
        }

        const targetSelected: any = [];
        const englishSelected: any = [];

        value.forEach(item => {
          const { rowKey, colKey, value: cellValue } = item;

          // Handle row mapping
          let rowIndex = -1;
          if (field.data_entry_language === 'en') {
            rowIndex = field.field_row_value.findIndex(row => row === rowKey);
          } else if (dataEntryLocalization) {
            rowIndex = dataEntryLocalization.localized_field_row_value.findIndex(row => row === rowKey);
          }

          // Handle column mapping
          let colIndex = -1;
          if (field.data_entry_language === 'en') {
            colIndex = field.field_value.findIndex(col => col === colKey);
          } else if (dataEntryLocalization) {
            colIndex = dataEntryLocalization.localized_field_value.findIndex(col => col === colKey);
          }

          const englishRowKey = rowIndex !== -1 ? field.field_row_value[rowIndex] : rowKey;
          const englishColKey = colIndex !== -1 ? field.field_value[colIndex] : colKey;

          const targetRowKey = targetLanguage === 'en' ?
            englishRowKey :
            (rowIndex !== -1 ? targetLocalization.localized_field_row_value[rowIndex] : rowKey);
          const targetColKey = targetLanguage === 'en' ?
            englishColKey :
            (colIndex !== -1 ? targetLocalization.localized_field_value[colIndex] : colKey);

          englishSelected.push({ rowKey: englishRowKey, colKey: englishColKey, value: cellValue });
          targetSelected.push({ rowKey: targetRowKey, colKey: targetColKey, value: cellValue });
        });

        englishFieldValue = englishSelected;
        targetFieldValue = targetSelected;
        break;
      }

      default: {
        // For other field types, return as is
        englishFieldValue = value;
        targetFieldValue = value;
        break;
      }
    }
    return {
      englishFieldValue: englishFieldValue,
      localizedFieldValue: targetFieldValue
    };
  };

  const dataURLtoBlob = (dataurl: string) => {
    let arr = dataurl.split(','), mime = arr[0].match(/:(.*?);/)![1],
      bstr = atob(arr[1]), n = bstr.length, u8arr = new Uint8Array(n);
    while (n--) {
      u8arr[n] = bstr.charCodeAt(n);
    }
    return new Blob([u8arr], { type: mime });
  }

  /**
 * submit data to server
 */
  const submitSurvey = async (reason = "") => {
    setCloseWebSocketConnection(true);
    try {
      dispatch(setLoading(true));
      setIsLoading(true);
      let fieldsArray: any = [];
      let tempFormFields: any = cloneDeep(formFields);
      tempFormFields = flatMap(tempFormFields);
      let endTime = new Date();

      // Process all fields sequentially
      for (let i = 0; i < tempFormFields.length; i++) {
        const obj = tempFormFields[i];

        if (fileUploadFields.includes(obj.field_type)) {
          const isFile = obj.field_selected_value instanceof File || obj.field_selected_value instanceof Blob;
          const isDataURL = typeof obj.field_selected_value === 'string' &&
            obj.field_selected_value.startsWith('data:');
          const isNewFileUpload = (Array.isArray(obj.field_selected_value) &&
            obj.field_selected_value.length > 0) || isDataURL || isFile;
          const isExistingFile = typeof obj.field_selected_value === 'string' &&
            obj.field_selected_value.trim() !== '' && !isDataURL;

          if (isNewFileUpload) {
            // New file uploaded - call upload API
            const formFileData = new FormData();
            if (isDataURL) {
              const blob = dataURLtoBlob(obj.field_selected_value);
              const extension = blob.type.split('/')[1] || 'png';
              formFileData.append('file', blob, `signature_${Date.now()}.${extension}`);
            } else if (obj.field_type === "fileUpload" || obj.field_type === "fileUploadOCR") {
              formFileData.append('file', obj.field_selected_value[0]);
            } else {
              formFileData.append('file', obj.field_selected_value);
            }

            try {
              const result = await new Promise((resolve, reject) => {
                uploadDoc(formFileData, resolve, reject);
              });
              obj.field_selected_value = result;
            } catch (error) {
              obj.field_selected_value = '';
            }
          } else if (isExistingFile) {
            // Existing file - keep the string value as is
            // No upload needed, obj.field_selected_value already contains the filename string
          } else {
            // No file selected
            obj.field_selected_value = '';
          }
        }

        const fieldValueObj: any = processFieldValue(obj, obj.field_selected_value, 'en');
        if (obj.field_type === 'dropDown' || obj.field_type === 'dropDownPreviousResponses') {
          obj.field_selected_value = fieldValueObj?.englishFieldValue?.value;
        }
        else if (Array.isArray(fieldValueObj?.englishFieldValue)) {
          obj.field_selected_value = fieldValueObj?.englishFieldValue;
        } else if (
          fieldValueObj?.englishFieldValue !== null &&
          typeof fieldValueObj?.englishFieldValue == "object" &&
          !gridFields.includes(obj.field_type) &&
          !["dateField", "dateTime"].includes(obj.field_type)
        ) {
          obj.field_selected_value = fieldValueObj?.englishFieldValue?.value;
        } else {
          obj.field_selected_value = fieldValueObj?.englishFieldValue;
        }

        // ✅ Format date/time fields without milliseconds
        if (obj.field_type === "dateField" || obj.field_type === "dateTime") {
          if (obj.field_selected_value) {
            const d = new Date(obj.field_selected_value);
            obj.field_selected_value = d.toISOString().replace(/\.\d{3}Z$/, "Z");
          }
        }

        // ✅ Subtract 5:30 hrs (IST offset) from time fields before sending
        if (obj.field_type === "time" && obj.field_selected_value) {
          obj.field_selected_value = convertISTTimeToUTC(obj.field_selected_value);
        }

        obj.field_selected_value_score = processFieldScores(obj, obj.field_selected_value);

        // Revert field types for Communication_P_C form
        let typeToSend = obj.field_type;
        if (
          (componentState?.data?.form_name.includes(COMMUNICATION_CC_PC) ||
            componentState?.data?.form_name.includes(COMMUNICATION_CC_MSG_LK)) &&
          ["Form Name", "Field Name"].includes(obj.field_name)
        ) {
          typeToSend = "textBox";
        } else if (componentState?.data?.form_name.includes(COMMUNICATION_CC_TC) && ["Target Uid Form", "Target Form Users", "Target Data Collection Form", "Target Uid Form Id", "Target Form Users Id"].includes(obj.field_name)) {
          typeToSend = "textBox";
        } else if (
          componentState?.data?.form_name.includes(COMMUNICATION_CC_SC) &&
          ["Schedule Form", "Watch Field", "Target Uid Form", "Target Form Users"].includes(obj.field_name)
        ) {
          typeToSend = "textBox";
        }
        let selectedVal = obj.field_selected_value;
        if (componentState?.data?.form_name.includes(COMMUNICATION_CC_TC)) {
          if (obj.field_name === "Target Uid Form") {
            if (selectedVal === "null_value" || (typeof selectedVal === 'object' && selectedVal?.value === "null_value")) {
              selectedVal = null;
            } else if (Array.isArray(selectedVal)) {
              selectedVal = selectedVal.map(item => item.value);
            }
          } else if (obj.field_name === "Target Form Users") {
            if (Array.isArray(selectedVal)) {
              selectedVal = selectedVal.map(item => item.field_selected_value || item.value || item);
            }
          } else if (obj.field_name === "Target Form Users Id") {
            const usersField = tempFormFields.find(f => f.field_name === "Target Form Users");
            const usersValue = usersField?.field_selected_value;
            selectedVal = Array.isArray(usersValue)
              ? usersValue.map(item => {
                if (item === null || item === undefined) return null;
                if (typeof item === "string") return item;
                return item?.record_id || item?.value || null;
              }).filter(Boolean)
              : [];
          } else if (obj.field_name === "Target Data Collection Form") {
            if (Array.isArray(selectedVal)) {
              selectedVal = selectedVal.map(item => item.value ?? item);
            } else if (selectedVal && typeof selectedVal === "object") {
              selectedVal = selectedVal.value ?? selectedVal;
            }
          }
        } else if (componentState?.data?.form_name.includes(COMMUNICATION_CC_SC)) {
          if (obj.field_name === "Target Uid Form") {
            if (selectedVal === "null_value" || (typeof selectedVal === 'object' && selectedVal?.value === "null_value")) {
              selectedVal = null;
            } else if (Array.isArray(selectedVal)) {
              selectedVal = selectedVal.map(item => item.value);
            }
          } else if (obj.field_name === "Target Form Users") {
            if (Array.isArray(selectedVal)) {
              selectedVal = selectedVal.map(item => item.field_selected_value || item.value || item);
            }
          } else if (obj.field_name === "Target Form Users Id") {
            const usersField = tempFormFields.find(f => f.field_name === "Target Form Users");
            const usersValue = usersField?.field_selected_value;
            selectedVal = Array.isArray(usersValue)
              ? usersValue.map(item => {
                if (item === null || item === undefined) return null;
                if (typeof item === "string") return item;
                return item?.record_id || item?.value || null;
              }).filter(Boolean)
              : [];
          }
        } else if (obj.field_name === "Target Form Users Id") {
          const usersField = tempFormFields.find(f => f.field_name === "Target Form Users");
          const usersValue = usersField?.field_selected_value;
          selectedVal = Array.isArray(usersValue)
            ? usersValue.map(item => {
              if (item === null || item === undefined) return null;
              if (typeof item === "string") return item;
              return item?.record_id || item?.value || null;
            }).filter(Boolean)
            : [];
        }

        if (obj.field_type === 'multiSelect' && Array.isArray(selectedVal)) {
          selectedVal = selectedVal.map(item => (typeof item === 'object' && item !== null) ? (item.value ?? item) : item);
        }

        fieldsArray.push({
          id: obj.id || obj.fieldId,
          field_selected_value: selectedVal,
          field_selected_value_score: obj.field_selected_value_score,
          field_type: typeToSend,
          field_name: obj.field_name,
        });
      }

      // After all fields are processed
      let versionid: number = Number(localStorage.getItem("versionid"));
      const tz = Intl.DateTimeFormat().resolvedOptions().timeZone;
      let uidData = tempFormFields?.flat().find(itm => itm.field_use_type?.includes('UID'));
      let masterUid = uidData?.field_selected_value.trim();
      let masterUidFieldId = uidData?.id;

      let reqObj: any = {
        "form_id": formData?.id,
        "version_id": versionid,
        "fields": fieldsArray,
        "start_time": formStartTime,
        "end_time": endTime,
        "time_zone": tz,
        "master_uid": masterUid || "",
        "master_uid_field_id": masterUidFieldId || "",
        "update_remarks": reason,
      }
      let response: any;
      if (moduleType === "dataEntry") {
        if (isModifyData) {
          reqObj.id = location?.state?.responseId || location?.state?.id || props?.data?.recordId || "";
          response = await updateIdentifierForm(reqObj);
        } else {
          response = await submitIdentifierForm(reqObj);
        }
      }
      else {
        response = await submitForm(reqObj);
      }
      if (response.success) {
        showToaster(toasterTypes.SUCCESS, response.message);
        const device = window.innerWidth > 750 ? "desktop" : "mobile";
        const message = response?.custom_message || "";
        const customColorLogic = formData?.custom_color_logic || "";

        const score = response?.total_score || 0;
        const customMsg = formatCustomMessage(message, score, customColorLogic);

        setCustomMessage(customMsg);
        setIsSubmit(false);
        localStorage.setItem("indexno", JSON.stringify({ pageno: 0 }));
        localStorage.setItem("answerdata", JSON.stringify([]));
        localStorage.setItem("formdatastore", JSON.stringify([]));

        // After successful submission
        const params = new URLSearchParams(window.location.search);
        const formId = params.get('formId');
        incrementSubmissionCount(formId || formData?.id);
        setIsSubmitted(true);
        flushSync(() => setCloseWebSocketConnection(true));

        if (props?.moduleType !== "surveyForm") {
          closeTimeoutRef.current = setTimeout(() => {
            handleClose();
          }, 5000)
        }
      } else {
        setIsSubmit(false);
        updateErrorObj(response.data);
        showToaster(toasterTypes.ERROR, response.custom_message || response.message);
      }
      dispatch(setLoading(false));
      setIsLoading(false);
    } catch (e: any) {
      dispatch(setLoading(false));
      console.error("Submission Error:", e);
      setIsLoading(false);
    } finally {
      dispatch(setLoading(false));
      setIsLoading(false);
    }
  }

  const updateErrorObj = (data) => {
    let tempData: any = cloneDeep(formFields);
    let errorObj: any = [];
    data && data.forEach((field) => {
      let index = tempData[page]?.findIndex((f) => f.id === field.field_id);
      errorObj.push({ name: index, data: { hasError: true, errorMsg: field.msg || "Please Enter the values correctly." } })
    })
    if (errorObj.length === 0) {
      removeErrors();
    } else {
      updateAllError(errorObj);
    }
  }

  // Get localized form name based on selected language
  const getLocalizedFormName = (form) => {
    if (selectedLanguage?.value === 'en' || !form.is_localized) {
      return form?.form_name;
    }

    const localization = form.localized.find(loc => loc.language === selectedLanguage.value);
    return localization?.localized_value || form?.form_name;
  };

  const getLocalizedFieldName = (field) => {
    if (selectedLanguage?.value === 'en' || !field?.is_localized) {
      return field?.field_name;
    }

    const localization = field.localized.find(loc => loc.language === selectedLanguage.value);
    return localization?.localized_value || field.field_name;
  };


  const getDisplayValue = (field) => {
    const { englishFieldValue, localizedFieldValue }: any = processFieldValue(
      field,
      field.field_selected_value,
      selectedLanguage.value || 'en'
    );

    const raw = localizedFieldValue ?? englishFieldValue ?? field.field_selected_value ?? "";

    //For dropdown types, return the full object so FieldItem can match it
    if (
      ["dropDown", "dropDownPreviousResponses", "multiSelect"].includes(field.field_type)
    ) {
      if (Array.isArray(raw)) {
        return raw.map(val => {
          if (typeof val === 'string') return { label: val, value: val };
          return val;
        });
      }
      if (raw && typeof raw === "object" && !Array.isArray(raw)) {
        // Guard: only return the object if it has a meaningful label or value
        if (raw.label != null || raw.value != null) {
          return raw; // return full {label, value} object
        }
        return null;
      }
      // If it's a string, wrap it into an option object
      if (raw && typeof raw === "string") {
        return { label: raw, value: raw };
      }
      return raw;
    }

    // For all other field types, unwrap object to string
    if (raw && typeof raw === "object" && !Array.isArray(raw)) {
      return raw.label ?? raw.value ?? "";
    }

    return raw;
  };

  // Get localized field values (options) based on selected language
  const getLocalizedFieldValues = (field) => {
    let values = [];
    if (selectedLanguage?.value === 'en' || !field.is_localized) {
      values = field.field_value;
    } else {
      const localization = field.localized.find(loc => loc.language === selectedLanguage.value);
      values = localization?.localized_field_value || field.field_value;
    }

    // Ensure options are in {label, value} format for dropdown/multiselect
    if (["dropDown", "multiSelect", "dropDownPreviousResponses"].includes(field.field_type)) {
      if (Array.isArray(values)) {
        return values.map(val => {
          if (typeof val === 'string') {
            return { label: val, value: val };
          }
          return val;
        });
      }
    }
    return values;
  };

  // Get localized field values (options) based on selected language
  const getLocalizedFieldRowValues = (field) => {
    if (selectedLanguage?.value === 'en' || !field.is_localized) {
      return field.field_row_value;
    }
    const localization = field.localized.find(loc => loc.language === selectedLanguage.value);
    return localization?.localized_field_row_value || field.field_row_value;
  };

  const getLanguageValues = () => {
    let temp: any = formData;
    const formLanguages = temp?.localized || [];
    const otherLanguages = languagesData.filter(
      lang =>
        lang.value !== "en" && formLanguages.some(i => i.language === lang.value)
    );
    const english = languagesData.find(lang => lang.value === "en");
    return english ? [english, ...otherLanguages] : otherLanguages;
  };

  const handleLanguageChange = (e) => {
    setSelectedLanguage(e);
  };

  /**
  * get category to print
  */

  const getUniqueCategory = (page: number, index: number, formFields: any[][]): string | null => {
    const field = formFields[page][index];
    const category = field.field_category?.trim();

    if (!category) return null;

    // Ensure the Set is initialized
    if (!renderedCategoriesRef.has(page)) {
      renderedCategoriesRef.set(page, new Set());
    }

    // Use non-null assertion (!) since we just ensured it exists
    const pageCategorySet = renderedCategoriesRef.get(page)!;

    if (!pageCategorySet.has(category)) {
      pageCategorySet.add(category);
      return category;
    }

    return null;
  };

  const getColumnSize = (fieldId: string): number => {
    const device = window.innerWidth > 756 ? "desktop" : "mobile";
    if (device === "mobile") {
      return 100;
    }
    let varSize = configData && configData.filter(flt =>
      flt['var_id'] === fieldId
    )
    if (varSize && varSize.length > 0) {
      switch (varSize[0].var_size) {
        case 1:
          return 22;
        case 2:
          return 48;
        case 3:
          return 74;
        case 4:
          return 100;
        default:
          return 48;
      }
    } else {
      return 48;
    }
  }

  const getSearchIndexTabs = async (data) => {
    const tz = Intl.DateTimeFormat().resolvedOptions().timeZone;
    let temp = location.state;
    let searchVal: any = "";

    if (data.field_type == "dropDownPreviousResponses" || data.field_type == "dropDown") {
      if (typeof data.field_selected_value === "object") {
        searchVal = data.field_selected_value?.value;
      } else {
        searchVal = data.field_selected_value;
      }
    } else {
      searchVal = data.field_selected_value;
    }

    let Obj = [{
      "field_id": data.id,
      "search_value": searchVal,
      "field_type": data.field_type,
      "time_zone": tz
    }];

    let perData = projectDataPerm.projectPermissionData?.filter(
      itm => itm.projectId == temp.projectData.id
    );
    let permArray = {};

    perData && perData[0]?.permissionData.forEach((obj) => {
      if (Object.keys(obj)[0] == "Data") {
        obj[Object.keys(obj)[0]].forEach((objItem) => {
          permArray[objItem.action] = objItem.permissions.filter(
            itemflt => itemflt.title == "allowed"
          )[0]?.is_selected;
        });
      } else if (Object.keys(obj)[0] == "Forms") {
        obj[Object.keys(obj)[0]].forEach((objItem) => {
          permArray[objItem.action] = objItem.permissions.filter(
            itemflt => itemflt.title == "allowed"
          )[0]?.is_selected;
        });
      }
    });

    setSearchIndexUidData(Obj);
    setPermissionData(permArray);

    try {
      dispatch(setLoading(true));
      let response = await postSearchIndex(
        temp.projectData.TopicID,
        temp.data.id,
        Obj,
        permArray['all data view']
      );

      if (response) {
        setExistingData(response.data);
        let checkData = response.data.filter(elem => elem.count_info.length > 0);

        if (checkData.length > 0) {
          // Instead of opening modal, show tabs
          setShowSearchIndexTabs(true);
        } else {
          showToaster(toasterTypes.ERROR, "No data found");
        }
      }
      dispatch(setLoading(false));
    } catch (error) {
      dispatch(setLoading(false));
    }
  };


  /**
   * get serach index 
   */
  const getSearchIndex = async (data) => {
    const tz = Intl.DateTimeFormat().resolvedOptions().timeZone;
    let temp = location.state;
    let searchVal: any = "";
    if (data.field_type == "dropDownPreviousResponses" || data.field_type == "dropDown") {
      if (typeof data.field_selected_value === "object") {
        searchVal = data.field_selected_value?.value
      } else {
        searchVal = data.field_selected_value
      }
    } else {
      searchVal = data.field_selected_value
    }

    let Obj = [{ "field_id": data.id, "search_value": searchVal, "field_type": data.field_type, "time_zone": tz }]
    let perData = projectDataPerm.projectPermissionData?.filter(itm => itm.projectId == temp.projectData.id)
    let permArray = {};
    perData && perData[0]?.permissionData.forEach((obj) => {
      if (Object.keys(obj)[0] == "Data") {
        obj[Object.keys(obj)[0]].forEach((objItem) => {
          permArray[objItem.action] = objItem.permissions.filter(itemflt => itemflt.title == "allowed")[0]?.is_selected
        })
        //setPermission(obj[Object.keys(obj)[0]])
      } else if (Object.keys(obj)[0] == "Forms") {
        obj[Object.keys(obj)[0]].forEach((objItem) => {
          permArray[objItem.action] = objItem.permissions.filter(itemflt => itemflt.title == "allowed")[0]?.is_selected
        })
      }
    })
    setSearchIndexUidData(Obj);
    setPermissionData(permArray)
    try {
      dispatch(setLoading(true));
      let response = await postSearchIndex(temp.projectData.TopicID, temp.data.id, Obj, permArray['all data view']);
      if (response) {
        setExistingData(response.data)
        let checkData = response.data.filter(elem => elem.count_info.length > 0)
        if (checkData.length > 0) {
          setIsExist(true)
        } else {
          showToaster(toasterTypes.ERROR, "No data found")
        }
      }
      dispatch(setLoading(false));

    } catch (error) {
      dispatch(setLoading(false));
    }
  }

  /**
  * get data from search index
  */
  const getExistingData = async (data) => {
    if (!data?.fields) return;

    const updatedFormFields = await next({
      currentFormFields: formFields,
      getBackData: true
    }) || [...formFields];

    setExistSelectedData(data);

    const fieldMap = new Map();
    updatedFormFields.forEach(row => {
      row.forEach(field => fieldMap.set(field.id, field));
    });

    // Update field values
    data.fields.forEach(elem => {
      const field = fieldMap.get(elem.id);
      if (!field) return;

      field.field_selected_value = elem.field_type === "dropDown"
        ? { label: elem.field_selected_value, value: elem.field_selected_value }
        : elem.field_selected_value;
    });

    // Check if current page is complete
    const currentPageFields = updatedFormFields[page];
    const isAllFieldsFilled = currentPageFields?.every(field => {
      if (field.field_type === "checkBox") {
        return Array.isArray(field.field_selected_value) &&
          field.field_selected_value.length > 0;
      }
      return field.field_selected_value != null &&
        field.field_selected_value !== "";
    }) ?? false;

    setShouldProceed(isAllFieldsFilled);
    setFormFields(updatedFormFields);
    removeErrors();
  };

  const onClose = () => {
    setIsLocked(false);
    setIsExist(false);
  }

  const handleClose = () => {
    if (hasCalledClose.current) return;
    hasCalledClose.current = true;
    if (closeTimeoutRef.current) {
      clearTimeout(closeTimeoutRef.current);
    }
    props?.onClose?.();
  };

  const getReason = (reason) => {
    if (reason && reason.length > 0) {
      submitSurvey(reason);
    } else {
      showToaster(toasterTypes.ERROR, "Please enter the reason to submit the form.");
      setIsLocked(false);
      return;
    }
    setIsLocked(false);
  }

  const getAcceptedFiles = (field_type) => {
    switch (field_type) {
      case "fileUploadOCR":
        return "jpeg|pdf";
      case "fileUpload":
        return "pdf|png|csv|jpeg|jpg|svg";
      case "imageCapture":
        return "png|jpeg|jpg";
      case "videoCapture":
        return "webm|mp4|mov|avi";
      case "audioCapture":
        return "webm|mp3|wav|m4a|ogg";
      case "signatureCapture":
        return "png|jpeg|jpg";
      default:
        return undefined;
    }
  }

  const updateFormFieldsWithReceivedData = (formFields, fieldsData) => {
    if (!fieldsData || fieldsData.length === 0) {
      return null;
    }

    const updatedFields = formFields[page]?.map((field) => {
      const fieldData = fieldsData.find(f => f.id === field.id);

      if (
        fieldData &&
        fieldData.field_selected_value !== null &&
        fieldData.field_selected_value !== "null" &&
        fieldData.field_selected_value !== ""
      ) {
        if (field.field_type === "dropDown") {
          field.field_selected_value = {
            label: fieldData.field_selected_value,
            value: fieldData.field_selected_value,
          };
        } else if (field.field_type === "dateField") {
          // Convert to ISO format
          const isoDate = new Date(fieldData.field_selected_value).toISOString();
          field.field_selected_value = isoDate;
        } else {
          field.field_selected_value = fieldData.field_selected_value;
        }
      }

      return field;
    });

    formFields[page] = updatedFields;
    return formFields;
  };


  useEffect(() => {
    const temp = cloneDeep(formFields);
    const formFieldsToUpdate = updateFormFieldsWithReceivedData(temp, receivedFieldsData);
    // Update the form fields state
    if (formFieldsToUpdate) {
      setFormFields(formFieldsToUpdate);
    }
  }, [receivedFieldsData])

  useEffect(() => {
    if (autofillFieldValues && autofillFieldValues.length > 0) {
      const updatedFormFields = applyAutofillToFields(formFields, autofillFieldValues);
      setFormFields(updatedFormFields);
      // Clear autofill values after applying to prevent re-application
      setAutofillFieldValues([]);
    }
  }, [autofillFieldValues])

  const onTableSubmit = (isSub, isSubmitd) => {
    setIsSubmit(isSub);
    setIsSubmitted(isSubmitd);
  }


  const getTableFormData = () => {
    const isTableArray = Array(page + 1).fill(false);
    isTableArray[page] = true;
    let tempState = location.state;
    const updatedFormData = tempState?.data || props?.formData;
    const tableData = {
      id: updatedFormData.id,
      isTable: isTableArray,
      form_fields: formFields
    }
    return tableData;
  }

  const getUidField = (type = "value") => {
    const uidField = formFields
      ?.flatMap(fields => fields)
      .find(field => field.field_use_type.includes("UID"));

    if (!uidField || !uidField.field_selected_value) {
      return type === "exists" ? false : "";
    }

    if (type === "exists") {
      return true;
    }

    if (type === "name") {
      return uidField.field_name || "";
    }

    if (type === "SearchIndex") {
      const isSearchIndex = uidField.field_use_type.includes("SearchIndex");
      return isSearchIndex ? uidField : null;
    }

    const val = uidField.field_selected_value;

    if (typeof val === "object") {
      return type === "value" ? val.value || "" : "";
    }

    // If it's a string, return directly
    return val;
  };


  const navigateToSpeechToTextPage = (type) => {

    switch (type) {
      case "stt":
        navigate('/speechToText', { state: { selectedFormData: props.data, projectData: props.projectData, isCreditsAvailable: true } });
        break;
      case "stt_conversation":
        navigate('/speechToTextConversation', { state: { selectedFormData: props.data, projectData: props.projectData, isCreditsAvailable: true } });
        break;
      default:
        break;
    }
  }


  function formatCustomMessage(
    message: string,
    score?: number,
    customColorLogic?: string
  ): (string | JSX.Element)[][] {
    if (!message || message.length === 0) return [];

    const rows = message.split('##');
    const result: (string | JSX.Element)[][] = [];

    const colorRegex = /<color:(#[0-9A-Fa-f]{6}|[a-zA-Z]+)>(.*?)<\/color>/g;
    const customColorRegex = /<custom_color>(.*?)<\/custom_color>/g;

    // --- Evaluate custom color logic ---
    function evaluateColorLogic(logic?: string, score?: number): string {
      if (!logic || score === undefined) return 'black';
      try {
        const parser = new Parser();
        const expression = parser.parse(logic);
        const color = expression.evaluate({ score });
        return typeof color === 'string' ? color : 'black';
      } catch (error) {
        console.error('Invalid color logic:', error);
        return 'black';
      }
    }

    const customColor = evaluateColorLogic(customColorLogic, score);

    for (let rowIndex = 0; rowIndex < rows.length; rowIndex++) {
      const row = rows[rowIndex];
      const columns = row
        .split('**')
        .map((col) => col.trim())
        .filter(Boolean)
        .map((col, colIndex) => {
          const parts: (string | JSX.Element)[] = [];
          let remaining = col;

          // Process both types of tags in a single pass
          const allTagsRegex = /<(color:(#[0-9A-Fa-f]{6}|[a-zA-Z]+)|custom_color)>(.*?)<\/(color|custom_color)>/g;
          let lastIndex = 0;
          let match;

          allTagsRegex.lastIndex = 0;

          while ((match = allTagsRegex.exec(col)) !== null) {
            // Add text before the tag
            if (match.index > lastIndex) {
              parts.push(col.slice(lastIndex, match.index));
            }

            // Determine which tag type and extract color/text
            const tagType = match[1]; // 'color:...' or 'custom_color'
            const text = match[3];

            if (tagType.startsWith('color:')) {
              const color = match[2]; // The color value
              parts.push(
                <span key={`${rowIndex}-${colIndex}-${match.index}`} style={{ color }}>
                  {text}
                </span>
              );
            } else {
              // custom_color tag
              parts.push(
                <span key={`${rowIndex}-${colIndex}-${match.index}`} style={{ color: customColor }}>
                  {text}
                </span>
              );
            }

            lastIndex = allTagsRegex.lastIndex;
          }

          // Add remaining text after last tag
          if (lastIndex < col.length) {
            parts.push(col.slice(lastIndex));
          }

          return parts.length > 0 ? parts : [col];
        });

      result.push(columns.flat());
    }

    return result;
  }

  // Extract your main form into a separate function (add this before the return statement)
  const renderMainForm = () => (
    <div className="survey-form-component-container">
      <div className='close-container'>
        {props?.moduleType !== "surveyForm" && (
          <i
            className='icon icon-close'
            onClick={() => {
              flushSync(() => setCloseWebSocketConnection(true));
              handleClose();
            }}
          />
        )}
      </div>

      <div className='coguide-banner-container'>
        {formData?.banner_image ? (
          <img
            src={`https://go.coguide.in/c1/download/${formData.banner_image}`}
            alt='preview-banner'
            className='banner'
          />
        ) : (
          <img
            src={`${process.env.PUBLIC_URL}/images/survey_tools.svg`}
            alt='preview-banner'
            className='banner'
          />
        )}
      </div>

      <div className='coguide-logo-container'>
        <img
          src={`${process.env.PUBLIC_URL}/images/powered_by_coguide2.png`}
          alt='logo'
          className='logo'
        />
      </div>

      <div className='name-container'>
        <div className='p-0 left-container'>
          <div className='form-name'>{getLocalizedFormName(formData)}</div>
          <div className='form-description'>{formData?.form_desc}</div>
          {getUidField("exists") && (
            <>
              <div className='selected-uid'>
                {getUidField("name")} : {getUidField("value")}
                {getUidField("SearchIndex") && (
                  <DatabaseFilled
                    style={{ color: "var(--primary-color, #007bff)", fontSize: "20px", marginLeft: "5px" }}
                    onClick={() => getSearchIndexTabs(getUidField("SearchIndex"))}
                  />
                )}
              </div>
            </>
          )}
        </div>

        {!isSubmitted && !isCurrentFormSubmitted && (
          <div className="right-container">
            <div className='language'>
              <FieldItem
                {...SurveyFormElements.language}
                values={getLanguageValues()}
                isMandatory={false}
                value={selectedLanguage}
                onChange={(...e) => handleLanguageChange(...e)}
              />
            </div>

            <SpeechToTextButton
              onClick={() => navigateToSpeechToTextPage("stt")}
              isCreditsAvailable={true}
              projectData={formData}
            />

            {conversationFormNames?.some(word =>
              formData?.form_name?.toLowerCase().includes(word)
            ) && (
                <SttConversationButton
                  onClick={() => navigateToSpeechToTextPage("stt_conversation")}
                  isCreditsAvailable={true}
                  projectData={formData}
                />
              )}
          </div>
        )}
      </div>

      {isSubmitted ? (
        <div className="survey-form-submit">
          <div className='questions-container row flex-column m-0 justify-content-center align-items-center pt-0'>
            <CheckCircleOutlined className="tick-icon" />
            <div className='completed-text1'>Successfully submitted your form.</div>
            {customMessage && customMessage.length > 0 &&
              customMessage.map((row, index) => (
                <div key={index} style={{ display: 'flex', gap: '10px' }}>
                  {row.map((msg, i) => (
                    <div
                      key={i}
                      className="custom-message"
                      style={{ fontWeight: index === 0 ? 'bold' : 'normal' }}
                    >
                      {msg}
                    </div>
                  ))}
                </div>
              ))
            }
          </div>
        </div>
      ) : isCurrentFormSubmitted ? (
        <div className="survey-form-cookie-submit">
          <p>{currentFormSubmittedMessage}</p>
        </div>
      ) : (
        <div className="survey-form-fields-container">
          <div className="form-body">
            <Row className="fields-container">
              {!tableView ? (
                formFields && formFields.length > 0 && formFields[page]?.map((obj, index) => {
                  if (obj.is_hidden) return null;
                  const category = getUniqueCategory(page, index, formFields);
                  return (
                    <>
                      {category && (
                        <Col md={12} className="category" key={`${obj.id}+${index}`}>
                          <hr />
                          <h5>{category}</h5>
                        </Col>
                      )}
                      <Col
                        sm={12}
                        md="auto"
                        style={{ maxWidth: `${getColumnSize(obj.id)}%`, overflow: 'auto' }}
                        key={obj.id}
                        className={`field-col ${fields[index] && fields[index].hasError ? "error" : ""}`}
                      >
                        <div className="field-body">
                          <FieldItem
                            name={obj.id}
                            placeholder={
                              obj.field_type === "number" ||
                                obj.field_type === "textBox" ||
                                obj.field_type === "textArea" ||
                                obj.field_type === "password"
                                ? "Enter"
                                : "Select"
                            }
                            isDisabled={
                              disabledFields.includes(obj.id) ||
                              (isModifyPartial && !modifyPartialFieldIds.includes(obj.id))
                            }
                            label={
                              obj.field_type === "instruction"
                                ? ""
                                : getLocalizedFieldName(obj)
                            }
                            type={
                              obj.field_type === "multiSelect"
                                ? FIELD_TYPES.MULTI_SELECT
                                : obj.field_type === "fileUpload"
                                  ? FIELD_TYPES.FILE_UPLOAD
                                  : obj.field_type === "dateField"
                                    ? FIELD_TYPES.DATEPICKER_NEW
                                    : obj.field_type === "dropDown"
                                      ? FIELD_TYPES.DROP_DOWN
                                      : obj.field_type === "dropDownPreviousResponses"
                                        ? FIELD_TYPES.DROP_DOWN
                                        : obj.field_type === "boolean"
                                          ? FIELD_TYPES.BOOLEAN
                                          : obj.field_type === "radioButton"
                                            ? FIELD_TYPES.RADIO_BUTTON
                                            : obj.field_type === "checkBox"
                                              ? FIELD_TYPES.CHECK_BOX
                                              : obj.field_type === "textArea"
                                                ? FIELD_TYPES.TEXT_AREA
                                                : obj.field_type === "textBox"
                                                  ? FIELD_TYPES.TEXT
                                                  : obj.field_type === "time"
                                                    ? FIELD_TYPES.TIME_PICKER
                                                    : obj.field_type === "dateTime"
                                                      ? FIELD_TYPES.DATE_TIME_PICKER
                                                      : obj.field_type === "signatureCapture"
                                                        ? FIELD_TYPES.SIGNATURE_CAPTURE
                                                        : obj.field_type === "imageCapture"
                                                          ? FIELD_TYPES.IMAGE_CAPTURE
                                                          : obj.field_type === "videoCapture"
                                                            ? FIELD_TYPES.VIDEO_CAPTURE
                                                            : obj.field_type === "audioCapture"
                                                              ? FIELD_TYPES.AUDIO_CAPTURE
                                                              : obj.field_type === "instruction"
                                                                ? FIELD_TYPES.INPUT_INSTRUCTION
                                                                : obj.field_type === "checkBoxGrid"
                                                                  ? FIELD_TYPES.CHECK_BOX_GRID
                                                                  : obj.field_type === "radioButtonGrid"
                                                                    ? FIELD_TYPES.RADIO_BUTTON_GRID
                                                                    : obj.field_type === "textBoxGrid"
                                                                      ? FIELD_TYPES.TEXT_BOX_GRID
                                                                      : obj.field_type === "fileUploadOCR"
                                                                        ? FIELD_TYPES.FILE_UPLOAD
                                                                        : obj.field_type === "password"
                                                                          ? FIELD_TYPES.PASSWORD
                                                                          : FIELD_TYPES.TEXT
                            }
                            isNumber={obj.field_type === "number"}
                            value={
                              obj.field_type === "instruction"
                                ? getLocalizedFieldName(obj)
                                : getDisplayValue(obj)
                            }
                            values={getLocalizedFieldValues(obj)}
                            rowValues={getLocalizedFieldRowValues(obj)}
                            isListed={true}
                            touched={fields[index] && fields[index].hasError}
                            error={fields[index] && fields[index].errorMsg}
                            onChange={(...e) => {
                              handleChange(obj.id, ...e);
                            }}
                            acceptFiles={getAcceptedFiles(obj.field_type)}
                            maxLimit={10 * 1024 * 1024}
                            onBlur={() => handleOnBlur(obj, index, formFields)}
                          />
                        </div>
                        {obj?.field_use_type?.includes("SearchIndex") && (
                          <div
                            className="search-index-container"
                            title="Search existing data"
                            onClick={() => getSearchIndex(obj)}
                          >
                            <DatabaseFilled
                              style={{ color: "var(--primary-color, #007bff)", fontSize: "20px" }}
                            />
                          </div>
                        )}
                      </Col>
                    </>
                  );
                })
              ) : (
                <TableViewData
                  existData={[]}
                  formData={getTableFormData()}
                  onTableSubmit={onTableSubmit}
                  rules={[]}
                  isMasterFlow={isMasterFlow}
                  masterUidData={masterUidData}
                />
              )}
            </Row>
          </div>

          <Row className="navigation-buttons">
            <CustomButton
              type="primary"
              onClick={previous}
              text="Previous"
              isDisabled={page === 0}
            />
            {!tableView && (
              <CustomButton
                type="primary"
                onClick={next}
                text="Next"
              />
            )}
          </Row>
        </div>
      )}
    </div>
  );

  return (
    <>
      {isLocked && (
        <ModifyReasonModal
          getReasonData={getReason}
          isClose={() => onClose()}
        />
      )}
      {
        isExist ?
          <ExistingDataModal isClose={() => onClose()} existingData={existingData} getExistingData={getExistingData} topicId={projectData?.TopicID} searchIndexUidData={searchIndexUidData} />
          :
          ""
      }

      {isSubmit && (
        <ModalPopup
          modalType='submit'
          modalText={submitMessage}
          actionText="Do you want to submit the form?"
          closeModal={() => setIsSubmit(false)}
          onAction={() => {
            formData && formData["locked"] &&
              modifyReasonTypes.includes(componentState?.modifyType)
              ? setIsLocked(true)
              : submitSurvey()
          }}
          disabled={isLoading}
        />
      )}

      {/* Conditionally render SearchIndexTabs or regular form */}
      {showSearchIndexTabs ? (
        <SearchIndexTabs
          existingData={existingData}
          getExistingData={(data) => {
            // getExistingData(data);
            setAutofillFieldValues(data?.fields || []);
            setShowSearchIndexTabs(false);
          }}
          topicId={projectData?.TopicID}
          searchIndexUidData={searchIndexUidData}
          onClose={() => setShowSearchIndexTabs(false)}
          renderDataEntryForm={() => renderMainForm()}
          renderType={"dataEntry"}
        />
      ) : (
        renderMainForm()
      )}
    </>
  );
}

export default SurveyFormComponent